// // ============================================================
// // src/components/Appointment.js
// // ============================================================
// import React, { useState } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// export default function Appointment({ showToast }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: "",
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);
//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: "",
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   return (
//     <section className="appointment" id="appointment">
//       <div className="appointment-inner">
//         <div className="appointment-left">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Fill in your details and we'll confirm your appointment via WhatsApp
//             within 30 minutes.
//           </p>
//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div>
//           <div className="form-card">
//             <div className="form-title">Request Appointment</div>
//             <div className="form-subtitle">
//               Form fills your WhatsApp with appointment details
//               <span className="wa-badge">WhatsApp</span>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Full Name *</label>
//                 <input
//                   type="text"
//                   placeholder="Your name"
//                   value={form.name}
//                   onChange={(e) => set("name", e.target.value)}
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Phone Number *</label>
//                 <input
//                   type="tel"
//                   placeholder="+91 98765 43210"
//                   value={form.phone}
//                   onChange={(e) => set("phone", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Service Required *</label>
//               <select
//                 value={form.service}
//                 onChange={(e) => set("service", e.target.value)}
//               >
//                 <option value="">Select a service</option>
//                 {[
//                   "General Checkup & Cleaning",
//                   "Teeth Whitening",
//                   "Dental Implants",
//                   "Root Canal",
//                   "Orthodontics / Invisalign",
//                   "Cosmetic Dentistry",
//                   "Pediatric Dentistry",
//                   "Emergency Care",
//                   "Other",
//                 ].map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Preferred Date *</label>
//                 <input
//                   type="date"
//                   value={form.date}
//                   onChange={(e) => set("date", e.target.value)}
//                   min={new Date().toISOString().split("T")[0]}
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Preferred Time</label>
//                 <select
//                   value={form.time}
//                   onChange={(e) => set("time", e.target.value)}
//                 >
//                   <option value="">Any time</option>
//                   {[
//                     "9:00 AM",
//                     "9:30 AM",
//                     "10:00 AM",
//                     "10:30 AM",
//                     "11:00 AM",
//                     "11:30 AM",
//                     "12:00 PM",
//                     "2:00 PM",
//                     "2:30 PM",
//                     "3:00 PM",
//                     "3:30 PM",
//                     "4:00 PM",
//                     "4:30 PM",
//                     "5:00 PM",
//                     "5:30 PM",
//                     "6:00 PM",
//                     "6:30 PM",
//                     "7:00 PM",
//                   ].map((t) => (
//                     <option key={t} value={t}>
//                       {t}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Message / Concern (Optional)</label>
//               <textarea
//                 placeholder="Describe your dental concern or any special instructions..."
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />
//             </div>
//             <button
//               className="form-submit"
//               onClick={handleWhatsApp}
//               disabled={submitting}
//             >
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                 <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//               </svg>
//               {submitting ? "Sending..." : "Send via WhatsApp →"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// // ============================================================
// // src/components/Appointment.js
// // ============================================================
// import React, { useState, useEffect } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// export default function Appointment({ showToast }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: "",
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);

//   useEffect(() => {
//     let interval;
//     let attempts = 0;

//     const fetchDoctors = () => {
//       api
//         .get("/auth/doctors")
//         .then((data) => {
//           if (Array.isArray(data) && data.length > 0) {
//             setDoctors(data);
//             setDoctorsLoaded(true);
//             // Once loaded successfully, slow down polling to 5 seconds
//             clearInterval(interval);
//             interval = setInterval(fetchDoctors, 5000);
//           }
//         })
//         .catch(() => {});
//       attempts++;
//     };

//     // Try immediately, then every 2 seconds until doctors load
//     fetchDoctors();
//     interval = setInterval(fetchDoctors, 2000);

//     return () => clearInterval(interval);
//   }, []);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);
//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: "",
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   return (
//     <section className="appointment" id="appointment">
//       <div className="appointment-inner">
//         <div className="appointment-left">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Fill in your details and we'll confirm your appointment via WhatsApp
//             within 30 minutes.
//           </p>
//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* ── Doctor Availability Section ─────────────────── */}
//           <div style={{ marginTop: "28px" }}>
//             <div
//               style={{
//                 fontSize: "13px",
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: "12px",
//               }}
//             >
//               🩺 Doctors Available Today
//             </div>

//             {/* Loading skeleton — shows immediately while fetching */}
//             {!doctorsLoaded && (
//               <div
//                 style={{ display: "flex", flexDirection: "column", gap: "8px" }}
//               >
//                 {[1, 2, 3].map((i) => (
//                   <div
//                     key={i}
//                     style={{
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: "1px solid #e5e7eb",
//                       background: "#f8fafc",
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       animation: "pulse 1.5s ease-in-out infinite",
//                     }}
//                   >
//                     <div>
//                       <div
//                         style={{
//                           width: "120px",
//                           height: "14px",
//                           borderRadius: "6px",
//                           background: "#e2e8f0",
//                           marginBottom: "6px",
//                         }}
//                       />
//                       <div
//                         style={{
//                           width: "80px",
//                           height: "10px",
//                           borderRadius: "6px",
//                           background: "#f1f5f9",
//                         }}
//                       />
//                     </div>
//                     <div
//                       style={{
//                         width: "80px",
//                         height: "22px",
//                         borderRadius: "12px",
//                         background: "#e2e8f0",
//                       }}
//                     />
//                   </div>
//                 ))}
//                 <style>{`
//                   @keyframes pulse {
//                     0%, 100% { opacity: 1; }
//                     50%       { opacity: 0.5; }
//                   }
//                 `}</style>
//               </div>
//             )}

//             {/* Actual doctor list — shows once loaded */}
//             {doctorsLoaded && (
//               <div
//                 style={{ display: "flex", flexDirection: "column", gap: "8px" }}
//               >
//                 {doctors.map((doc) => (
//                   <div
//                     key={doc._id}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       padding: "10px 14px",
//                       borderRadius: "10px",
//                       border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
//                       background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
//                       opacity: doc.isAvailable ? 1 : 0.6,
//                       transition: "all 0.3s",
//                     }}
//                   >
//                     <div>
//                       <div
//                         style={{
//                           fontWeight: 600,
//                           fontSize: "14px",
//                           color: doc.isAvailable ? "#166534" : "#991b1b",
//                         }}
//                       >
//                         {doc.name}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "12px",
//                           color: "#64748b",
//                           marginTop: "2px",
//                         }}
//                       >
//                         {doc.specialty || "General Dentist"}
//                       </div>
//                     </div>
//                     <span
//                       style={{
//                         padding: "3px 10px",
//                         borderRadius: "12px",
//                         fontSize: "11px",
//                         fontWeight: 700,
//                         background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
//                         color: doc.isAvailable ? "#16a34a" : "#dc2626",
//                         border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//           {/* ── End Doctor Availability ───────────────────── */}
//         </div>
//         <div>
//           <div className="form-card">
//             <div className="form-title">Request Appointment</div>
//             <div className="form-subtitle">
//               Form fills your WhatsApp with appointment details
//               <span className="wa-badge">WhatsApp</span>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Full Name *</label>
//                 <input
//                   type="text"
//                   placeholder="Your name"
//                   value={form.name}
//                   onChange={(e) => set("name", e.target.value)}
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Phone Number *</label>
//                 <input
//                   type="tel"
//                   placeholder="+91 98765 43210"
//                   value={form.phone}
//                   onChange={(e) => set("phone", e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Service Required *</label>
//               <select
//                 value={form.service}
//                 onChange={(e) => set("service", e.target.value)}
//               >
//                 <option value="">Select a service</option>
//                 {[
//                   "General Checkup & Cleaning",
//                   "Teeth Whitening",
//                   "Dental Implants",
//                   "Root Canal",
//                   "Orthodontics / Invisalign",
//                   "Cosmetic Dentistry",
//                   "Pediatric Dentistry",
//                   "Emergency Care",
//                   "Other",
//                 ].map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Preferred Date *</label>
//                 <input
//                   type="date"
//                   value={form.date}
//                   onChange={(e) => set("date", e.target.value)}
//                   min={new Date().toISOString().split("T")[0]}
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Preferred Time</label>
//                 <select
//                   value={form.time}
//                   onChange={(e) => set("time", e.target.value)}
//                 >
//                   <option value="">Any time</option>
//                   {[
//                     "9:00 AM",
//                     "9:30 AM",
//                     "10:00 AM",
//                     "10:30 AM",
//                     "11:00 AM",
//                     "11:30 AM",
//                     "12:00 PM",
//                     "2:00 PM",
//                     "2:30 PM",
//                     "3:00 PM",
//                     "3:30 PM",
//                     "4:00 PM",
//                     "4:30 PM",
//                     "5:00 PM",
//                     "5:30 PM",
//                     "6:00 PM",
//                     "6:30 PM",
//                     "7:00 PM",
//                   ].map((t) => (
//                     <option key={t} value={t}>
//                       {t}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="form-group">
//               <label>Message / Concern (Optional)</label>
//               <textarea
//                 placeholder="Describe your dental concern or any special instructions..."
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />
//             </div>
//             <button
//               className="form-submit"
//               onClick={handleWhatsApp}
//               disabled={submitting}
//             >
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                 <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//               </svg>
//               {submitting ? "Sending..." : "Send via WhatsApp →"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

/////////////////////////////////////////////////above code is correct prato code below/////////

// // ============================================================
// // src/components/Appointment.js
// // Practo-style booking interface — fully responsive
// // NO auto-scroll on load, NO slot countdown
// // ============================================================
// import React, { useState, useEffect, useRef } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// // ── Local ISO date (no UTC shift) ────────────────────────────
// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// // ── Next 14 days ─────────────────────────────────────────────
// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// // ── Time slots (Practo-style 15-min intervals) ────────────────
// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];

// const SERVICES = [
//   "General Checkup & Cleaning",
//   "Teeth Whitening",
//   "Dental Implants",
//   "Root Canal",
//   "Orthodontics / Invisalign",
//   "Cosmetic Dentistry",
//   "Pediatric Dentistry",
//   "Emergency Care",
//   "Other",
// ];

// // ── CSS ───────────────────────────────────────────────────────
// const CSS = `
// /* ── outer layout ── */
// .appt-outer {
//   display: grid;
//   grid-template-columns: 1fr 1.35fr;
//   gap: 72px;
//   align-items: start;
// }

// /* ── left panel ── */
// .appt-left-info { display: flex; flex-direction: column; }

// /* ── booking card ── */
// .appt-card {
//   background: #fff;
//   border-radius: 20px;
//   box-shadow: 0 4px 32px rgba(0,0,0,.08);
//   overflow: hidden;
// }
// .appt-card-header {
//   background: linear-gradient(135deg,#0a1628 0%,#0d7377 100%);
//   padding: 22px 28px 18px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
// }
// .appt-card-header-icon {
//   width: 42px; height: 42px; border-radius: 50%;
//   background: rgba(255,255,255,.15);
//   display: flex; align-items: center; justify-content: center;
//   font-size: 20px; flex-shrink: 0;
// }
// .appt-card-header-text { flex: 1; min-width: 0; }
// .appt-card-title { font-size: 16px; font-weight: 800; color: #fff; margin: 0; }
// .appt-card-sub   { font-size: 11px; color: rgba(255,255,255,.7); margin-top: 2px; }

// /* ── step sections ── */
// .appt-section { padding: 20px 24px 0; }
// .appt-section:last-child { padding-bottom: 24px; }
// .appt-section-label {
//   font-size: 11px; font-weight: 700; color: #64748b;
//   text-transform: uppercase; letter-spacing: .6px;
//   margin-bottom: 10px;
//   display: flex; align-items: center; gap: 6px;
// }
// .appt-section-label-dot {
//   width: 18px; height: 18px; border-radius: 50%;
//   background: linear-gradient(135deg,#0d7377,#14a0a5);
//   color: #fff; font-size: 9px; font-weight: 800;
//   display: flex; align-items: center; justify-content: center;
//   flex-shrink: 0;
// }
// .appt-divider { height: 1px; background: #f1f5f9; margin: 0 24px; }

// /* ── form inputs ── */
// .appt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
// .appt-inp-wrap  { display: flex; flex-direction: column; gap: 4px; }
// .appt-inp-wrap.full { grid-column: 1 / -1; }
// .appt-inp-label { font-size: 11px; font-weight: 600; color: #475569; }
// .appt-inp {
//   padding: 10px 12px; border-radius: 8px;
//   border: 1.5px solid #e2e8f0; font-size: 13px;
//   font-family: "DM Sans",sans-serif; outline: none;
//   transition: border-color .2s; background: #f8fafc;
//   width: 100%; box-sizing: border-box;
// }
// .appt-inp:focus { border-color: #0d7377; background: #fff; }
// .appt-textarea  { resize: vertical; min-height: 72px; }

// /* ── Practo date strip ── */
// .appt-date-strip {
//   display: flex;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none;
//   border: 1.5px solid #e2e8f0;
//   border-radius: 12px;
//   background: #f8fafc;
//   overflow: hidden;
// }
// .appt-date-strip::-webkit-scrollbar { display: none; }
// .appt-date-pill {
//   flex-shrink: 0;
//   padding: 12px 16px; cursor: pointer;
//   text-align: center; min-width: 88px;
//   border-right: 1px solid #e2e8f0;
//   transition: background .15s;
//   font-family: "DM Sans",sans-serif;
// }
// .appt-date-pill:last-child { border-right: none; }
// .appt-date-pill:hover  { background: rgba(13,115,119,.05); }
// .appt-date-pill.active { background: #0d7377; }
// .appt-date-day   { font-size: 13px; font-weight: 700; color: #1e293b; }
// .appt-date-avail { font-size: 10px; color: #16a34a; font-weight: 600; margin-top: 3px; }
// .appt-date-pill.active .appt-date-day   { color: #fff; }
// .appt-date-pill.active .appt-date-avail { color: rgba(255,255,255,.8); }
// .appt-date-scroll-hint {
//   font-size: 10px; color: #94a3b8;
//   margin-top: 5px; text-align: right;
// }

// /* ── selected date bar ── */
// .appt-date-bar {
//   background: #f8fafc; border: 1px solid #e2e8f0;
//   border-radius: 8px; padding: 9px 14px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
//   margin-bottom: 14px;
//   display: flex; align-items: center; justify-content: space-between;
// }
// .appt-date-bar-sub { color: #0d7377; font-size: 11px; font-weight: 600; }

// /* ── time period header ── */
// .appt-period-hdr {
//   display: flex; align-items: center; gap: 8px;
//   margin: 16px 0 10px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
// }
// .appt-period-count {
//   background: #f1f5f9; border: 1px solid #e2e8f0;
//   border-radius: 20px; padding: 2px 10px;
//   font-size: 10px; color: #64748b; font-weight: 600;
// }

// /* ── slot grid — 4 columns ── */
// .appt-slots-grid {
//   display: grid;
//   grid-template-columns: repeat(4,1fr);
//   gap: 8px;
// }
// .appt-slot {
//   padding: 10px 6px; border-radius: 8px;
//   border: 1.5px solid #0d7377; background: #fff;
//   cursor: pointer; text-align: center;
//   transition: all .15s; font-family: "DM Sans",sans-serif;
// }
// .appt-slot:hover {
//   background: #0d7377;
// }
// .appt-slot:hover .appt-slot-time { color: #fff; }
// .appt-slot.selected { background: #0d7377; border-color: #0d7377; }
// .appt-slot.selected .appt-slot-time { color: #fff; }
// .appt-slot-time { font-size: 12px; font-weight: 700; color: #0d7377; }

// /* ── submit button ── */
// .appt-submit {
//   width: 100%; padding: 14px;
//   background: linear-gradient(135deg,#25d366,#128c7e);
//   border: none; border-radius: 10px; cursor: pointer;
//   display: flex; align-items: center; justify-content: center; gap: 10px;
//   font-size: 15px; font-weight: 700; color: #fff;
//   font-family: "DM Sans",sans-serif;
//   transition: opacity .2s;
// }
// .appt-submit:hover     { opacity: .92; }
// .appt-submit:disabled  { opacity: .6; cursor: not-allowed; }

// /* ── doctor card ── */
// .appt-doc-card {
//   padding: 12px 14px; border-radius: 12px;
//   display: flex; align-items: center; gap: 12px;
//   border: 1px solid #e5e7eb; background: #f8fafc;
//   margin-bottom: 8px;
// }

// /* ── skeleton ── */
// @keyframes apptPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
// .appt-skel {
//   border-radius: 8px; background: #e2e8f0;
//   animation: apptPulse 1.5s ease-in-out infinite;
// }

// /* ══ RESPONSIVE ══════════════════════════════════════════════ */
// @media (max-width: 1024px) {
//   .appt-outer { gap: 48px; }
// }
// @media (max-width: 860px) {
//   .appt-outer {
//     grid-template-columns: 1fr !important;
//     gap: 28px !important;
//   }
//   .appt-card         { border-radius: 16px; }
//   .appt-card-header  { padding: 18px 20px 14px; }
//   .appt-section      { padding: 16px 18px 0; }
//   .appt-section:last-child { padding-bottom: 18px; }
//   .appt-divider      { margin: 0 18px; }
// }
// @media (max-width: 600px) {
//   .appt-card-header  { padding: 14px 16px 12px; }
//   .appt-card-title   { font-size: 14px; }
//   .appt-section      { padding: 14px 14px 0; }
//   .appt-section:last-child { padding-bottom: 16px; }
//   .appt-divider      { margin: 0 14px; }
//   .appt-form-grid    { grid-template-columns: 1fr !important; }
//   .appt-date-pill    { min-width: 72px; padding: 10px 10px; }
//   .appt-date-day     { font-size: 12px; }
//   .appt-slots-grid   { grid-template-columns: repeat(3,1fr) !important; gap: 6px; }
//   .appt-slot         { padding: 9px 4px; }
//   .appt-slot-time    { font-size: 11px; }
//   .appt-submit       { font-size: 14px; padding: 13px; }
// }
// @media (max-width: 380px) {
//   .appt-slots-grid        { grid-template-columns: repeat(2,1fr) !important; }
//   .appt-card-header-icon  { width: 34px; height: 34px; font-size: 16px; }
// }
// `;

// // ── Total slots for a date (all slots, none disabled) ─────────
// const TOTAL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots).length;

// export default function Appointment({ showToast }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: localISO(new Date()),
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);

//   // Ref for the date strip — used only for manual scroll via button, NOT on mount
//   const stripRef = useRef(null);
//   // Track if page has mounted — prevents auto-scroll on load
//   const mountedRef = useRef(false);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   // ── Fetch doctors list ─────────────────────────────────────
//   useEffect(() => {
//     const base =
//       process.env.REACT_APP_API_URL ||
//       "https://pearlsmial.pearlsmilefresh.com/api";
//     let iv;
//     const go = () => {
//       fetch(base + "/auth/doctors")
//         .then((r) => (r.ok ? r.json() : null))
//         .then((data) => {
//           if (Array.isArray(data) && data.length > 0) {
//             setDoctors(data);
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {});
//     };
//     go();
//     iv = setInterval(go, 10000);
//     return () => clearInterval(iv);
//   }, []);

//   // ── Scroll date strip on date change — only AFTER first user click ──
//   // Using mountedRef to skip the initial render scroll that causes
//   // the page to jump to the appointment section on load
//   useEffect(() => {
//     if (!mountedRef.current) {
//       mountedRef.current = true;
//       return; // skip first render — no scroll on load
//     }
//     // Only scroll the strip itself (inline: "center"), not the page
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill) {
//       // scrollIntoView with block:"nearest" to avoid page-level scroll
//       stripRef.current.scrollTo({
//         left:
//           pill.offsetLeft -
//           stripRef.current.offsetWidth / 2 +
//           pill.offsetWidth / 2,
//         behavior: "smooth",
//       });
//     }
//   }, [form.date]);

//   // ── Submit ─────────────────────────────────────────────────
//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);

//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: localISO(new Date()),
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>

//       <div className="appointment-inner appt-outer">
//         {/* ── LEFT column ── */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>

//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* Doctors */}
//           <div style={{ marginTop: 28 }}>
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//               }}
//             >
//               🩺 Doctors Available Today
//             </div>

//             {!doctorsLoaded ? (
//               [1, 2, 3].map((i) => (
//                 <div key={i} className="appt-doc-card">
//                   <div
//                     className="appt-skel"
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       className="appt-skel"
//                       style={{ width: "60%", height: 13, marginBottom: 6 }}
//                     />
//                     <div
//                       className="appt-skel"
//                       style={{ width: "40%", height: 10 }}
//                     />
//                   </div>
//                   <div
//                     className="appt-skel"
//                     style={{ width: 80, height: 22, borderRadius: 12 }}
//                   />
//                 </div>
//               ))
//             ) : doctors.length === 0 ? (
//               <div
//                 style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//               >
//                 Loading doctor info…
//               </div>
//             ) : (
//               doctors.map((doc) => (
//                 <div
//                   key={doc._id}
//                   className="appt-doc-card"
//                   style={{
//                     border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
//                     background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                       background: `linear-gradient(135deg,${doc.isAvailable ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 17,
//                       color: "#fff",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {(doc.name || "D")
//                       .replace(/^Dr\.\s*/i, "")
//                       .charAt(0)
//                       .toUpperCase()}
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: doc.isAvailable ? "#166534" : "#991b1b",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {doc.name}
//                     </div>
//                     <div
//                       style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                     >
//                       {doc.specialty || "General Dentist"}
//                     </div>
//                   </div>
//                   <span
//                     style={{
//                       padding: "3px 10px",
//                       borderRadius: 12,
//                       fontSize: 11,
//                       fontWeight: 700,
//                       flexShrink: 0,
//                       background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
//                       color: doc.isAvailable ? "#16a34a" : "#dc2626",
//                       border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
//                   </span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* ── RIGHT column — booking card ── */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             {/* Header */}
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   PearlSmile Dental Hospital — Book online, confirm via WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 — Details */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>
//                 Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {SERVICES.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 2 — Date */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>
//                 Select Date
//               </div>
//               <div className="appt-date-strip" ref={stripRef}>
//                 {DAYS.map((d) => (
//                   <div
//                     key={d.iso}
//                     className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                     onClick={() => {
//                       set("date", d.iso);
//                       set("time", "");
//                     }}
//                   >
//                     <div className="appt-date-day">{d.short}</div>
//                     <div className="appt-date-avail">{TOTAL_SLOTS} slots</div>
//                   </div>
//                 ))}
//               </div>
//               <div className="appt-date-scroll-hint">
//                 ← scroll for more dates →
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 3 — Time */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>
//                 Select Time Slot
//               </div>

//               {/* Selected date bar */}
//               <div className="appt-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span className="appt-date-bar-sub">
//                   {TOTAL_SLOTS} slots available
//                 </span>
//               </div>

//               {TIME_GROUPS.map((group) => (
//                 <div key={group.label}>
//                   <div className="appt-period-hdr">
//                     <span style={{ fontSize: 18 }}>{group.icon}</span>
//                     <span>{group.label}</span>
//                     <span className="appt-period-count">
//                       {group.slots.length} slots
//                     </span>
//                   </div>
//                   <div className="appt-slots-grid">
//                     {group.slots.map((t) => (
//                       <div
//                         key={t}
//                         className={`appt-slot${form.time === t ? " selected" : ""}`}
//                         onClick={() => set("time", form.time === t ? "" : t)}
//                       >
//                         <div className="appt-slot-time">{t}</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="appt-divider" />

//             {/* Step 4 — Message + Submit */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>
//                 Message (Optional)
//               </div>

//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern or any special instructions…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />

//               {/* Selected slot preview */}
//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   ✅ Selected:&nbsp;<strong>{selectedLabel}</strong>
//                   &nbsp;at&nbsp;
//                   <strong>{form.time}</strong>
//                 </div>
//               )}

//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending…" : "Book via WhatsApp →"}
//               </button>

//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

//// diable slot code below/////

// // ============================================================
// // src/components/Appointment.js
// // Practo-style booking interface — fully responsive
// // NO auto-scroll on load, NO slot countdown
// // Past time slots disabled when today is selected
// // Date strip always scrollable (fixed overflow issue)
// // ============================================================
// import React, { useState, useEffect, useRef } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// // ── Local ISO date (no UTC shift) ────────────────────────────
// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// // ── Next 14 days ─────────────────────────────────────────────
// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// // ── Time slots (Practo-style 15-min intervals) ────────────────
// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];

// const SERVICES = [
//   "General Checkup & Cleaning",
//   "Teeth Whitening",
//   "Dental Implants",
//   "Root Canal",
//   "Orthodontics / Invisalign",
//   "Cosmetic Dentistry",
//   "Pediatric Dentistry",
//   "Emergency Care",
//   "Other",
// ];

// // ── Convert "09:00 AM" / "01:30 PM" → minutes since midnight ─
// function slotToMinutes(slot) {
//   const [time, meridiem] = slot.split(" ");
//   let [h, m] = time.split(":").map(Number);
//   if (meridiem === "PM" && h !== 12) h += 12;
//   if (meridiem === "AM" && h === 12) h = 0;
//   return h * 60 + m;
// }

// // ── Is this slot in the past for today? ──────────────────────
// function isSlotPast(slot) {
//   const now = new Date();
//   const nowMinutes = now.getHours() * 60 + now.getMinutes();
//   return slotToMinutes(slot) <= nowMinutes;
// }

// // ── Count available (non-past) slots for a given date ────────
// function getAvailableCount(iso) {
//   const todayISO = localISO(new Date());
//   if (iso !== todayISO) {
//     return TIME_GROUPS.flatMap((g) => g.slots).length;
//   }
//   return TIME_GROUPS.flatMap((g) => g.slots).filter((s) => !isSlotPast(s))
//     .length;
// }

// // ── Total slots (for future dates) ───────────────────────────
// const TOTAL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots).length;

// // ── CSS ───────────────────────────────────────────────────────
// const CSS = `
// /* ── outer layout ── */
// .appt-outer {
//   display: grid;
//   grid-template-columns: 1fr 1.35fr;
//   gap: 72px;
//   align-items: start;
// }

// /* ── left panel ── */
// .appt-left-info { display: flex; flex-direction: column; }

// /* ── booking card ── */
// .appt-card {
//   background: #fff;
//   border-radius: 20px;
//   box-shadow: 0 4px 32px rgba(0,0,0,.08);
//   overflow: hidden;
// }
// .appt-card-header {
//   background: linear-gradient(135deg,#0a1628 0%,#0d7377 100%);
//   padding: 22px 28px 18px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
// }
// .appt-card-header-icon {
//   width: 42px; height: 42px; border-radius: 50%;
//   background: rgba(255,255,255,.15);
//   display: flex; align-items: center; justify-content: center;
//   font-size: 20px; flex-shrink: 0;
// }
// .appt-card-header-text { flex: 1; min-width: 0; }
// .appt-card-title { font-size: 16px; font-weight: 800; color: #fff; margin: 0; }
// .appt-card-sub   { font-size: 11px; color: rgba(255,255,255,.7); margin-top: 2px; }

// /* ── step sections ── */
// .appt-section { padding: 20px 24px 0; }
// .appt-section:last-child { padding-bottom: 24px; }
// .appt-section-label {
//   font-size: 11px; font-weight: 700; color: #64748b;
//   text-transform: uppercase; letter-spacing: .6px;
//   margin-bottom: 10px;
//   display: flex; align-items: center; gap: 6px;
// }
// .appt-section-label-dot {
//   width: 18px; height: 18px; border-radius: 50%;
//   background: linear-gradient(135deg,#0d7377,#14a0a5);
//   color: #fff; font-size: 9px; font-weight: 800;
//   display: flex; align-items: center; justify-content: center;
//   flex-shrink: 0;
// }
// .appt-divider { height: 1px; background: #f1f5f9; margin: 0 24px; }

// /* ── form inputs ── */
// .appt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
// .appt-inp-wrap  { display: flex; flex-direction: column; gap: 4px; }
// .appt-inp-wrap.full { grid-column: 1 / -1; }
// .appt-inp-label { font-size: 11px; font-weight: 600; color: #475569; }
// .appt-inp {
//   padding: 10px 12px; border-radius: 8px;
//   border: 1.5px solid #e2e8f0; font-size: 13px;
//   font-family: "DM Sans",sans-serif; outline: none;
//   transition: border-color .2s; background: #f8fafc;
//   width: 100%; box-sizing: border-box;
// }
// .appt-inp:focus { border-color: #0d7377; background: #fff; }
// .appt-textarea  { resize: vertical; min-height: 72px; }

// /* ── Practo date strip wrapper ── */
// .appt-date-strip-wrapper {
//   position: relative;
//   border: 1.5px solid #e2e8f0;
//   border-radius: 12px;
//   background: #f8fafc;
//   overflow: hidden;
// }

// /* ── Practo date strip ── */
// /* KEY FIX: overflow-x:auto here, NOT overflow:hidden on wrapper */
// .appt-date-strip {
//   display: flex;
//   overflow-x: auto;
//   overflow-y: hidden;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none;
//   cursor: grab;
//   user-select: none;
// }
// .appt-date-strip:active { cursor: grabbing; }
// .appt-date-strip::-webkit-scrollbar { display: none; }

// .appt-date-pill {
//   flex-shrink: 0;
//   padding: 12px 16px; cursor: pointer;
//   text-align: center; min-width: 88px;
//   border-right: 1px solid #e2e8f0;
//   transition: background .15s;
//   font-family: "DM Sans",sans-serif;
// }
// .appt-date-pill:last-child { border-right: none; }
// .appt-date-pill:hover  { background: rgba(13,115,119,.05); }
// .appt-date-pill.active { background: #0d7377; }
// .appt-date-day   { font-size: 13px; font-weight: 700; color: #1e293b; }
// .appt-date-avail { font-size: 10px; color: #16a34a; font-weight: 600; margin-top: 3px; }
// .appt-date-pill.active .appt-date-day   { color: #fff; }
// .appt-date-pill.active .appt-date-avail { color: rgba(255,255,255,.8); }

// /* ── scroll nav arrows ── */
// .appt-strip-nav {
//   display: flex; align-items: center; justify-content: space-between;
//   margin-top: 6px;
// }
// .appt-strip-arrow {
//   background: #f1f5f9; border: 1px solid #e2e8f0;
//   border-radius: 6px; width: 28px; height: 28px;
//   display: flex; align-items: center; justify-content: center;
//   cursor: pointer; font-size: 14px; color: #64748b;
//   transition: background .15s, color .15s;
//   flex-shrink: 0;
//   user-select: none;
// }
// .appt-strip-arrow:hover { background: #0d7377; color: #fff; border-color: #0d7377; }
// .appt-date-scroll-hint {
//   font-size: 10px; color: #94a3b8;
//   text-align: center; flex: 1;
// }

// /* ── selected date bar ── */
// .appt-date-bar {
//   background: #f8fafc; border: 1px solid #e2e8f0;
//   border-radius: 8px; padding: 9px 14px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
//   margin-bottom: 14px;
//   display: flex; align-items: center; justify-content: space-between;
// }
// .appt-date-bar-sub { color: #0d7377; font-size: 11px; font-weight: 600; }

// /* ── time period header ── */
// .appt-period-hdr {
//   display: flex; align-items: center; gap: 8px;
//   margin: 16px 0 10px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
// }
// .appt-period-count {
//   background: #f1f5f9; border: 1px solid #e2e8f0;
//   border-radius: 20px; padding: 2px 10px;
//   font-size: 10px; color: #64748b; font-weight: 600;
// }

// /* ── slot grid — 4 columns ── */
// .appt-slots-grid {
//   display: grid;
//   grid-template-columns: repeat(4,1fr);
//   gap: 8px;
// }

// /* ── available slot ── */
// .appt-slot {
//   padding: 10px 6px; border-radius: 8px;
//   border: 1.5px solid #0d7377; background: #fff;
//   cursor: pointer; text-align: center;
//   transition: all .15s; font-family: "DM Sans",sans-serif;
// }
// .appt-slot:hover { background: #0d7377; }
// .appt-slot:hover .appt-slot-time { color: #fff; }
// .appt-slot.selected { background: #0d7377; border-color: #0d7377; }
// .appt-slot.selected .appt-slot-time { color: #fff; }
// .appt-slot-time { font-size: 12px; font-weight: 700; color: #0d7377; }

// /* ── past / disabled slot ── */
// .appt-slot.past {
//   border-color: #e2e8f0;
//   background: #f8fafc;
//   cursor: not-allowed;
//   opacity: 0.45;
// }
// .appt-slot.past:hover { background: #f8fafc; }
// .appt-slot.past .appt-slot-time { color: #94a3b8; text-decoration: line-through; }
// .appt-slot.past:hover .appt-slot-time { color: #94a3b8; }

// /* ── submit button ── */
// .appt-submit {
//   width: 100%; padding: 14px;
//   background: linear-gradient(135deg,#25d366,#128c7e);
//   border: none; border-radius: 10px; cursor: pointer;
//   display: flex; align-items: center; justify-content: center; gap: 10px;
//   font-size: 15px; font-weight: 700; color: #fff;
//   font-family: "DM Sans",sans-serif;
//   transition: opacity .2s;
// }
// .appt-submit:hover     { opacity: .92; }
// .appt-submit:disabled  { opacity: .6; cursor: not-allowed; }

// /* ── doctor card ── */
// .appt-doc-card {
//   padding: 12px 14px; border-radius: 12px;
//   display: flex; align-items: center; gap: 12px;
//   border: 1px solid #e5e7eb; background: #f8fafc;
//   margin-bottom: 8px;
// }

// /* ── skeleton ── */
// @keyframes apptPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
// .appt-skel {
//   border-radius: 8px; background: #e2e8f0;
//   animation: apptPulse 1.5s ease-in-out infinite;
// }

// /* ══ RESPONSIVE ══════════════════════════════════════════════ */
// @media (max-width: 1024px) {
//   .appt-outer { gap: 48px; }
// }
// @media (max-width: 860px) {
//   .appt-outer {
//     grid-template-columns: 1fr !important;
//     gap: 28px !important;
//   }
//   .appt-card         { border-radius: 16px; }
//   .appt-card-header  { padding: 18px 20px 14px; }
//   .appt-section      { padding: 16px 18px 0; }
//   .appt-section:last-child { padding-bottom: 18px; }
//   .appt-divider      { margin: 0 18px; }
// }
// @media (max-width: 600px) {
//   .appt-card-header  { padding: 14px 16px 12px; }
//   .appt-card-title   { font-size: 14px; }
//   .appt-section      { padding: 14px 14px 0; }
//   .appt-section:last-child { padding-bottom: 16px; }
//   .appt-divider      { margin: 0 14px; }
//   .appt-form-grid    { grid-template-columns: 1fr !important; }
//   .appt-date-pill    { min-width: 72px; padding: 10px 10px; }
//   .appt-date-day     { font-size: 12px; }
//   .appt-slots-grid   { grid-template-columns: repeat(3,1fr) !important; gap: 6px; }
//   .appt-slot         { padding: 9px 4px; }
//   .appt-slot-time    { font-size: 11px; }
//   .appt-submit       { font-size: 14px; padding: 13px; }
//   .appt-strip-arrow  { display: none; }
// }
// @media (max-width: 380px) {
//   .appt-slots-grid        { grid-template-columns: repeat(2,1fr) !important; }
//   .appt-card-header-icon  { width: 34px; height: 34px; font-size: 16px; }
// }
// `;

// export default function Appointment({ showToast }) {
//   const todayISO = localISO(new Date());

//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: todayISO,
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);

//   // Re-render every minute so past slots get disabled as time passes
//   const [, setTick] = useState(0);
//   useEffect(() => {
//     const iv = setInterval(() => setTick((t) => t + 1), 60 * 1000);
//     return () => clearInterval(iv);
//   }, []);

//   const stripRef = useRef(null);
//   const mountedRef = useRef(false);

//   // ── Mouse drag-to-scroll state ────────────────────────────
//   const isDragging = useRef(false);
//   const dragStartX = useRef(0);
//   const scrollStartX = useRef(0);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const isToday = form.date === todayISO;
//   const isDisabled = (slot) => isToday && isSlotPast(slot);
//   const availableForDate = (iso) => getAvailableCount(iso);
//   const availableNow = availableForDate(form.date);

//   // ── Scroll strip by N pills ───────────────────────────────
//   const scrollStrip = (direction) => {
//     if (!stripRef.current) return;
//     const pillWidth = stripRef.current.children[0]?.offsetWidth || 90;
//     stripRef.current.scrollBy({
//       left: direction * pillWidth * 3,
//       behavior: "smooth",
//     });
//   };

//   // ── Mouse drag scroll handlers ────────────────────────────
//   const onMouseDown = (e) => {
//     isDragging.current = true;
//     dragStartX.current = e.clientX;
//     scrollStartX.current = stripRef.current.scrollLeft;
//   };
//   const onMouseMove = (e) => {
//     if (!isDragging.current) return;
//     const dx = e.clientX - dragStartX.current;
//     stripRef.current.scrollLeft = scrollStartX.current - dx;
//   };
//   const onMouseUp = () => {
//     isDragging.current = false;
//   };

//   // ── Fetch doctors list ─────────────────────────────────────
//   useEffect(() => {
//     const base =
//       process.env.REACT_APP_API_URL ||
//       "https://pearlsmial.pearlsmilefresh.com/api";
//     let iv;
//     const go = () => {
//       fetch(base + "/auth/doctors")
//         .then((r) => (r.ok ? r.json() : null))
//         .then((data) => {
//           if (Array.isArray(data) && data.length > 0) {
//             setDoctors(data);
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {});
//     };
//     go();
//     iv = setInterval(go, 10000);
//     return () => clearInterval(iv);
//   }, []);

//   // ── Scroll strip to active pill when date changes ─────────
//   useEffect(() => {
//     if (!mountedRef.current) {
//       mountedRef.current = true;
//       return;
//     }
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill) {
//       stripRef.current.scrollTo({
//         left:
//           pill.offsetLeft -
//           stripRef.current.offsetWidth / 2 +
//           pill.offsetWidth / 2,
//         behavior: "smooth",
//       });
//     }
//   }, [form.date]);

//   // ── Clear selected time if it becomes past ────────────────
//   useEffect(() => {
//     if (form.time && isToday && isSlotPast(form.time)) {
//       set("time", "");
//     }
//   });

//   // ── Submit ─────────────────────────────────────────────────
//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);
//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: todayISO,
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>

//       <div className="appointment-inner appt-outer">
//         {/* ── LEFT column ── */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>

//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* Doctors */}
//           <div style={{ marginTop: 28 }}>
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//               }}
//             >
//               🩺 Doctors Available Today
//             </div>

//             {!doctorsLoaded ? (
//               [1, 2, 3].map((i) => (
//                 <div key={i} className="appt-doc-card">
//                   <div
//                     className="appt-skel"
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       className="appt-skel"
//                       style={{ width: "60%", height: 13, marginBottom: 6 }}
//                     />
//                     <div
//                       className="appt-skel"
//                       style={{ width: "40%", height: 10 }}
//                     />
//                   </div>
//                   <div
//                     className="appt-skel"
//                     style={{ width: 80, height: 22, borderRadius: 12 }}
//                   />
//                 </div>
//               ))
//             ) : doctors.length === 0 ? (
//               <div
//                 style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//               >
//                 Loading doctor info…
//               </div>
//             ) : (
//               doctors.map((doc) => (
//                 <div
//                   key={doc._id}
//                   className="appt-doc-card"
//                   style={{
//                     border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
//                     background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                       background: `linear-gradient(135deg,${doc.isAvailable ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 17,
//                       color: "#fff",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {(doc.name || "D")
//                       .replace(/^Dr\.\s*/i, "")
//                       .charAt(0)
//                       .toUpperCase()}
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: doc.isAvailable ? "#166534" : "#991b1b",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {doc.name}
//                     </div>
//                     <div
//                       style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                     >
//                       {doc.specialty || "General Dentist"}
//                     </div>
//                   </div>
//                   <span
//                     style={{
//                       padding: "3px 10px",
//                       borderRadius: 12,
//                       fontSize: 11,
//                       fontWeight: 700,
//                       flexShrink: 0,
//                       background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
//                       color: doc.isAvailable ? "#16a34a" : "#dc2626",
//                       border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
//                   </span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* ── RIGHT column — booking card ── */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             {/* Header */}
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   PearlSmile Dental Hospital — Book online, confirm via WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 — Details */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>
//                 Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {SERVICES.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 2 — Date */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>
//                 Select Date
//               </div>

//               {/* Strip wrapper — no overflow:hidden here */}
//               <div className="appt-date-strip-wrapper">
//                 <div
//                   className="appt-date-strip"
//                   ref={stripRef}
//                   onMouseDown={onMouseDown}
//                   onMouseMove={onMouseMove}
//                   onMouseUp={onMouseUp}
//                   onMouseLeave={onMouseUp}
//                 >
//                   {DAYS.map((d) => (
//                     <div
//                       key={d.iso}
//                       className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                       onClick={() => {
//                         if (
//                           !isDragging.current ||
//                           Math.abs(
//                             dragStartX.current -
//                               (stripRef.current?.scrollLeft || 0),
//                           ) < 5
//                         ) {
//                           set("date", d.iso);
//                           set("time", "");
//                         }
//                       }}
//                     >
//                       <div className="appt-date-day">{d.short}</div>
//                       <div className="appt-date-avail">
//                         {availableForDate(d.iso)} slots
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Navigation arrows + hint */}
//               <div className="appt-strip-nav">
//                 <div
//                   className="appt-strip-arrow"
//                   onClick={() => scrollStrip(-1)}
//                   title="Scroll back"
//                 >
//                   &#8249;
//                 </div>
//                 <div className="appt-date-scroll-hint">
//                   ← drag or click arrows to scroll →
//                 </div>
//                 <div
//                   className="appt-strip-arrow"
//                   onClick={() => scrollStrip(1)}
//                   title="Scroll forward"
//                 >
//                   &#8250;
//                 </div>
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 3 — Time */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>
//                 Select Time Slot
//               </div>

//               <div className="appt-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span className="appt-date-bar-sub">
//                   {availableNow} slots available
//                 </span>
//               </div>

//               {TIME_GROUPS.map((group) => {
//                 const groupAvailable = isToday
//                   ? group.slots.filter((s) => !isSlotPast(s)).length
//                   : group.slots.length;
//                 return (
//                   <div key={group.label}>
//                     <div className="appt-period-hdr">
//                       <span style={{ fontSize: 18 }}>{group.icon}</span>
//                       <span>{group.label}</span>
//                       <span className="appt-period-count">
//                         {groupAvailable} slots
//                       </span>
//                     </div>
//                     <div className="appt-slots-grid">
//                       {group.slots.map((t) => {
//                         const disabled = isDisabled(t);
//                         const selected = form.time === t;
//                         return (
//                           <div
//                             key={t}
//                             className={`appt-slot${selected ? " selected" : ""}${disabled ? " past" : ""}`}
//                             onClick={() => {
//                               if (disabled) return;
//                               set("time", selected ? "" : t);
//                             }}
//                             title={
//                               disabled ? "This slot has already passed" : t
//                             }
//                           >
//                             <div className="appt-slot-time">{t}</div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             <div className="appt-divider" />

//             {/* Step 4 — Message + Submit */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>
//                 Message (Optional)
//               </div>

//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern or any special instructions…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />

//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   ✅ Selected:&nbsp;<strong>{selectedLabel}</strong>
//                   &nbsp;at&nbsp;<strong>{form.time}</strong>
//                 </div>
//               )}

//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending…" : "Book via WhatsApp →"}
//               </button>

//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

////////////////////////////// shoes avability ////////////////

// // ============================================================
// // src/components/Appointment.js
// // Practo-style booking interface — fully responsive
// // NO auto-scroll on load, NO slot countdown
// // ============================================================
// import React, { useState, useEffect, useRef } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// // ── Local ISO date (no UTC shift) ────────────────────────────
// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// // ── Next 14 days ─────────────────────────────────────────────
// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// // ── Time slots (Practo-style 15-min intervals) ────────────────
// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];

// const SERVICES = [
//   "General Checkup & Cleaning",
//   "Teeth Whitening",
//   "Dental Implants",
//   "Root Canal",
//   "Orthodontics / Invisalign",
//   "Cosmetic Dentistry",
//   "Pediatric Dentistry",
//   "Emergency Care",
//   "Other",
// ];

// // ── CSS ───────────────────────────────────────────────────────
// const CSS = `
// /* ── outer layout ── */
// .appt-outer {
//   display: grid;
//   grid-template-columns: 1fr 1.35fr;
//   gap: 72px;
//   align-items: start;
// }

// /* ── left panel ── */
// .appt-left-info { display: flex; flex-direction: column; }

// /* ── booking card ── */
// .appt-card {
//   background: #fff;
//   border-radius: 20px;
//   box-shadow: 0 4px 32px rgba(0,0,0,.08);
//   overflow: hidden;
// }
// .appt-card-header {
//   background: linear-gradient(135deg,#0a1628 0%,#0d7377 100%);
//   padding: 22px 28px 18px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
// }
// .appt-card-header-icon {
//   width: 42px; height: 42px; border-radius: 50%;
//   background: rgba(255,255,255,.15);
//   display: flex; align-items: center; justify-content: center;
//   font-size: 20px; flex-shrink: 0;
// }
// .appt-card-header-text { flex: 1; min-width: 0; }
// .appt-card-title { font-size: 16px; font-weight: 800; color: #fff; margin: 0; }
// .appt-card-sub   { font-size: 11px; color: rgba(255,255,255,.7); margin-top: 2px; }

// /* ── step sections ── */
// .appt-section { padding: 20px 24px 0; }
// .appt-section:last-child { padding-bottom: 24px; }
// .appt-section-label {
//   font-size: 11px; font-weight: 700; color: #64748b;
//   text-transform: uppercase; letter-spacing: .6px;
//   margin-bottom: 10px;
//   display: flex; align-items: center; gap: 6px;
// }
// .appt-section-label-dot {
//   width: 18px; height: 18px; border-radius: 50%;
//   background: linear-gradient(135deg,#0d7377,#14a0a5);
//   color: #fff; font-size: 9px; font-weight: 800;
//   display: flex; align-items: center; justify-content: center;
//   flex-shrink: 0;
// }
// .appt-divider { height: 1px; background: #f1f5f9; margin: 0 24px; }

// /* ── form inputs ── */
// .appt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
// .appt-inp-wrap  { display: flex; flex-direction: column; gap: 4px; }
// .appt-inp-wrap.full { grid-column: 1 / -1; }
// .appt-inp-label { font-size: 11px; font-weight: 600; color: #475569; }
// .appt-inp {
//   padding: 10px 12px; border-radius: 8px;
//   border: 1.5px solid #e2e8f0; font-size: 13px;
//   font-family: "DM Sans",sans-serif; outline: none;
//   transition: border-color .2s; background: #f8fafc;
//   width: 100%; box-sizing: border-box;
// }
// .appt-inp:focus { border-color: #0d7377; background: #fff; }
// .appt-textarea  { resize: vertical; min-height: 72px; }

// /* ── Practo date strip ── */
// .appt-date-strip {
//   display: flex;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none;
//   border: 1.5px solid #e2e8f0;
//   border-radius: 12px;
//   background: #f8fafc;
//   overflow: hidden;
// }
// .appt-date-strip::-webkit-scrollbar { display: none; }
// .appt-date-pill {
//   flex-shrink: 0;
//   padding: 12px 16px; cursor: pointer;
//   text-align: center; min-width: 88px;
//   border-right: 1px solid #e2e8f0;
//   transition: background .15s;
//   font-family: "DM Sans",sans-serif;
// }
// .appt-date-pill:last-child { border-right: none; }
// .appt-date-pill:hover  { background: rgba(13,115,119,.05); }
// .appt-date-pill.active { background: #0d7377; }
// .appt-date-day   { font-size: 13px; font-weight: 700; color: #1e293b; }
// .appt-date-avail { font-size: 10px; color: #16a34a; font-weight: 600; margin-top: 3px; }
// .appt-date-pill.active .appt-date-day   { color: #fff; }
// .appt-date-pill.active .appt-date-avail { color: rgba(255,255,255,.8); }
// .appt-date-scroll-hint {
//   font-size: 10px; color: #94a3b8;
//   margin-top: 5px; text-align: right;
// }

// /* ── selected date bar ── */
// .appt-date-bar {
//   background: #f8fafc; border: 1px solid #e2e8f0;
//   border-radius: 8px; padding: 9px 14px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
//   margin-bottom: 14px;
//   display: flex; align-items: center; justify-content: space-between;
// }
// .appt-date-bar-sub { color: #0d7377; font-size: 11px; font-weight: 600; }

// /* ── time period header ── */
// .appt-period-hdr {
//   display: flex; align-items: center; gap: 8px;
//   margin: 16px 0 10px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
// }
// .appt-period-count {
//   background: #f1f5f9; border: 1px solid #e2e8f0;
//   border-radius: 20px; padding: 2px 10px;
//   font-size: 10px; color: #64748b; font-weight: 600;
// }

// /* ── slot grid — 4 columns ── */
// .appt-slots-grid {
//   display: grid;
//   grid-template-columns: repeat(4,1fr);
//   gap: 8px;
// }
// .appt-slot {
//   padding: 10px 6px; border-radius: 8px;
//   border: 1.5px solid #0d7377; background: #fff;
//   cursor: pointer; text-align: center;
//   transition: all .15s; font-family: "DM Sans",sans-serif;
// }
// .appt-slot:hover {
//   background: #0d7377;
// }
// .appt-slot:hover .appt-slot-time { color: #fff; }
// .appt-slot.selected { background: #0d7377; border-color: #0d7377; }
// .appt-slot.selected .appt-slot-time { color: #fff; }
// .appt-slot-time { font-size: 12px; font-weight: 700; color: #0d7377; }

// /* ── submit button ── */
// .appt-submit {
//   width: 100%; padding: 14px;
//   background: linear-gradient(135deg,#25d366,#128c7e);
//   border: none; border-radius: 10px; cursor: pointer;
//   display: flex; align-items: center; justify-content: center; gap: 10px;
//   font-size: 15px; font-weight: 700; color: #fff;
//   font-family: "DM Sans",sans-serif;
//   transition: opacity .2s;
// }
// .appt-submit:hover     { opacity: .92; }
// .appt-submit:disabled  { opacity: .6; cursor: not-allowed; }

// /* ── doctor card ── */
// .appt-doc-card {
//   padding: 12px 14px; border-radius: 12px;
//   display: flex; align-items: center; gap: 12px;
//   border: 1px solid #e5e7eb; background: #f8fafc;
//   margin-bottom: 8px;
// }

// /* ── skeleton ── */
// @keyframes apptPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
// .appt-skel {
//   border-radius: 8px; background: #e2e8f0;
//   animation: apptPulse 1.5s ease-in-out infinite;
// }

// /* ══ RESPONSIVE ══════════════════════════════════════════════ */
// @media (max-width: 1024px) {
//   .appt-outer { gap: 48px; }
// }
// @media (max-width: 860px) {
//   .appt-outer {
//     grid-template-columns: 1fr !important;
//     gap: 28px !important;
//   }
//   .appt-card         { border-radius: 16px; }
//   .appt-card-header  { padding: 18px 20px 14px; }
//   .appt-section      { padding: 16px 18px 0; }
//   .appt-section:last-child { padding-bottom: 18px; }
//   .appt-divider      { margin: 0 18px; }
// }
// @media (max-width: 600px) {
//   .appt-card-header  { padding: 14px 16px 12px; }
//   .appt-card-title   { font-size: 14px; }
//   .appt-section      { padding: 14px 14px 0; }
//   .appt-section:last-child { padding-bottom: 16px; }
//   .appt-divider      { margin: 0 14px; }
//   .appt-form-grid    { grid-template-columns: 1fr !important; }
//   .appt-date-pill    { min-width: 72px; padding: 10px 10px; }
//   .appt-date-day     { font-size: 12px; }
//   .appt-slots-grid   { grid-template-columns: repeat(3,1fr) !important; gap: 6px; }
//   .appt-slot         { padding: 9px 4px; }
//   .appt-slot-time    { font-size: 11px; }
//   .appt-submit       { font-size: 14px; padding: 13px; }
// }
// @media (max-width: 380px) {
//   .appt-slots-grid        { grid-template-columns: repeat(2,1fr) !important; }
//   .appt-card-header-icon  { width: 34px; height: 34px; font-size: 16px; }
// }
// `;

// // ── Total slots for a date (all slots, none disabled) ─────────
// const TOTAL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots).length;

// export default function Appointment({ showToast }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: localISO(new Date()),
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);

//   // Ref for the date strip — used only for manual scroll via button, NOT on mount
//   const stripRef = useRef(null);
//   // Track if page has mounted — prevents auto-scroll on load
//   const mountedRef = useRef(false);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   // ── Fetch doctors list ─────────────────────────────────────
//   useEffect(() => {
//     const base =
//       process.env.REACT_APP_API_URL ||
//       "https://pearlsmial.pearlsmilefresh.com/api";
//     let iv;
//     const go = () => {
//       fetch(base + "/auth/doctors")
//         .then((r) => (r.ok ? r.json() : null))
//         .then((data) => {
//           if (Array.isArray(data) && data.length > 0) {
//             setDoctors(data);
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {});
//     };
//     go();
//     iv = setInterval(go, 10000);
//     return () => clearInterval(iv);
//   }, []);

//   // ── Scroll date strip on date change — only AFTER first user click ──
//   // Using mountedRef to skip the initial render scroll that causes
//   // the page to jump to the appointment section on load
//   useEffect(() => {
//     if (!mountedRef.current) {
//       mountedRef.current = true;
//       return; // skip first render — no scroll on load
//     }
//     // Only scroll the strip itself (inline: "center"), not the page
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill) {
//       // scrollIntoView with block:"nearest" to avoid page-level scroll
//       stripRef.current.scrollTo({
//         left:
//           pill.offsetLeft -
//           stripRef.current.offsetWidth / 2 +
//           pill.offsetWidth / 2,
//         behavior: "smooth",
//       });
//     }
//   }, [form.date]);

//   // ── Submit ─────────────────────────────────────────────────
//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);

//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: localISO(new Date()),
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>

//       <div className="appointment-inner appt-outer">
//         {/* ── LEFT column ── */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>

//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* Doctors */}
//           <div style={{ marginTop: 28 }}>
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//               }}
//             >
//               🩺 Doctors Available Today
//             </div>

//             {!doctorsLoaded ? (
//               [1, 2, 3].map((i) => (
//                 <div key={i} className="appt-doc-card">
//                   <div
//                     className="appt-skel"
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       className="appt-skel"
//                       style={{ width: "60%", height: 13, marginBottom: 6 }}
//                     />
//                     <div
//                       className="appt-skel"
//                       style={{ width: "40%", height: 10 }}
//                     />
//                   </div>
//                   <div
//                     className="appt-skel"
//                     style={{ width: 80, height: 22, borderRadius: 12 }}
//                   />
//                 </div>
//               ))
//             ) : doctors.length === 0 ? (
//               <div
//                 style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//               >
//                 Loading doctor info…
//               </div>
//             ) : (
//               doctors.map((doc) => (
//                 <div
//                   key={doc._id}
//                   className="appt-doc-card"
//                   style={{
//                     border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
//                     background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                       background: `linear-gradient(135deg,${doc.isAvailable ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 17,
//                       color: "#fff",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {(doc.name || "D")
//                       .replace(/^Dr\.\s*/i, "")
//                       .charAt(0)
//                       .toUpperCase()}
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: doc.isAvailable ? "#166534" : "#991b1b",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {doc.name}
//                     </div>
//                     <div
//                       style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                     >
//                       {doc.specialty || "General Dentist"}
//                     </div>
//                   </div>
//                   <span
//                     style={{
//                       padding: "3px 10px",
//                       borderRadius: 12,
//                       fontSize: 11,
//                       fontWeight: 700,
//                       flexShrink: 0,
//                       background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
//                       color: doc.isAvailable ? "#16a34a" : "#dc2626",
//                       border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
//                   </span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* ── RIGHT column — booking card ── */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             {/* Header */}
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   PearlSmile Dental Hospital — Book online, confirm via WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 — Details */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>
//                 Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {SERVICES.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 2 — Date */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>
//                 Select Date
//               </div>
//               <div className="appt-date-strip" ref={stripRef}>
//                 {DAYS.map((d) => (
//                   <div
//                     key={d.iso}
//                     className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                     onClick={() => {
//                       set("date", d.iso);
//                       set("time", "");
//                     }}
//                   >
//                     <div className="appt-date-day">{d.short}</div>
//                     <div className="appt-date-avail">{TOTAL_SLOTS} slots</div>
//                   </div>
//                 ))}
//               </div>
//               <div className="appt-date-scroll-hint">
//                 ← scroll for more dates →
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 3 — Time */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>
//                 Select Time Slot
//               </div>

//               {/* Selected date bar */}
//               <div className="appt-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span className="appt-date-bar-sub">
//                   {TOTAL_SLOTS} slots available
//                 </span>
//               </div>

//               {TIME_GROUPS.map((group) => (
//                 <div key={group.label}>
//                   <div className="appt-period-hdr">
//                     <span style={{ fontSize: 18 }}>{group.icon}</span>
//                     <span>{group.label}</span>
//                     <span className="appt-period-count">
//                       {group.slots.length} slots
//                     </span>
//                   </div>
//                   <div className="appt-slots-grid">
//                     {group.slots.map((t) => (
//                       <div
//                         key={t}
//                         className={`appt-slot${form.time === t ? " selected" : ""}`}
//                         onClick={() => set("time", form.time === t ? "" : t)}
//                       >
//                         <div className="appt-slot-time">{t}</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="appt-divider" />

//             {/* Step 4 — Message + Submit */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>
//                 Message (Optional)
//               </div>

//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern or any special instructions…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />

//               {/* Selected slot preview */}
//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   ✅ Selected:&nbsp;<strong>{selectedLabel}</strong>
//                   &nbsp;at&nbsp;
//                   <strong>{form.time}</strong>
//                 </div>
//               )}

//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending…" : "Book via WhatsApp →"}
//               </button>

//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

////////////////////////////// test 3//////////////////
// // ============================================================
// // src/components/Appointment.js
// // Practo-style booking interface — fully responsive
// // NO auto-scroll on load, NO slot countdown
// // Past time slots disabled for today
// // ============================================================
// import React, { useState, useEffect, useRef } from "react";
// import api from "../utils/api";

// const PHONE = "+91 87936 08083";
// const WA_NUMBER = "918793608083";

// // ── Local ISO date (no UTC shift) ────────────────────────────
// function localISO(d) {
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// }

// // ── Next 14 days ─────────────────────────────────────────────
// function getNext14Days() {
//   const days = [];
//   for (let i = 0; i < 14; i++) {
//     const d = new Date();
//     d.setDate(d.getDate() + i);
//     const iso = localISO(d);
//     const short = d.toLocaleDateString("en-IN", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//     });
//     const full = d.toLocaleDateString("en-IN", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//     });
//     days.push({
//       iso,
//       short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
//       full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
//     });
//   }
//   return days;
// }
// const DAYS = getNext14Days();

// // ── Time slots ────────────────────────────────────────────────
// const TIME_GROUPS = [
//   {
//     label: "Morning",
//     icon: "🌅",
//     slots: [
//       "09:00 AM",
//       "09:15 AM",
//       "09:30 AM",
//       "09:45 AM",
//       "10:00 AM",
//       "10:15 AM",
//       "10:30 AM",
//       "10:45 AM",
//       "11:00 AM",
//       "11:15 AM",
//       "11:30 AM",
//       "11:45 AM",
//     ],
//   },
//   {
//     label: "Afternoon",
//     icon: "☀️",
//     slots: [
//       "12:00 PM",
//       "12:15 PM",
//       "12:30 PM",
//       "12:45 PM",
//       "01:00 PM",
//       "01:15 PM",
//       "01:30 PM",
//       "01:45 PM",
//       "02:00 PM",
//       "02:15 PM",
//       "02:30 PM",
//       "02:45 PM",
//       "03:00 PM",
//       "03:15 PM",
//       "03:30 PM",
//       "03:45 PM",
//     ],
//   },
//   {
//     label: "Evening",
//     icon: "🌆",
//     slots: [
//       "04:00 PM",
//       "04:15 PM",
//       "04:30 PM",
//       "04:45 PM",
//       "05:00 PM",
//       "05:15 PM",
//       "05:30 PM",
//       "05:45 PM",
//       "06:00 PM",
//       "06:15 PM",
//       "06:30 PM",
//       "06:45 PM",
//       "07:00 PM",
//     ],
//   },
// ];

// const SERVICES = [
//   "General Checkup & Cleaning",
//   "Teeth Whitening",
//   "Dental Implants",
//   "Root Canal",
//   "Orthodontics / Invisalign",
//   "Cosmetic Dentistry",
//   "Pediatric Dentistry",
//   "Emergency Care",
//   "Other",
// ];

// // ── Convert "09:00 AM" → minutes since midnight ───────────────
// function slotToMinutes(slot) {
//   const [time, period] = slot.split(" ");
//   let [h, m] = time.split(":").map(Number);
//   if (period === "PM" && h !== 12) h += 12;
//   if (period === "AM" && h === 12) h = 0;
//   return h * 60 + m;
// }

// // ── Is this slot in the past for today? ───────────────────────
// function isSlotPast(slot, selectedDate) {
//   const todayISO = localISO(new Date());
//   if (selectedDate !== todayISO) return false; // future dates — never disabled
//   const now = new Date();
//   const nowMinutes = now.getHours() * 60 + now.getMinutes();
//   return slotToMinutes(slot) <= nowMinutes;
// }

// // ── CSS ───────────────────────────────────────────────────────
// const CSS = `
// /* ── outer layout ── */
// .appt-outer {
//   display: grid;
//   grid-template-columns: 1fr 1.35fr;
//   gap: 72px;
//   align-items: start;
// }

// /* ── left panel ── */
// .appt-left-info { display: flex; flex-direction: column; }

// /* ── booking card ── */
// .appt-card {
//   background: #fff;
//   border-radius: 20px;
//   box-shadow: 0 4px 32px rgba(0,0,0,.08);
//   overflow: hidden;
// }
// .appt-card-header {
//   background: linear-gradient(135deg,#0a1628 0%,#0d7377 100%);
//   padding: 22px 28px 18px;
//   display: flex;
//   align-items: center;
//   gap: 12px;
// }
// .appt-card-header-icon {
//   width: 42px; height: 42px; border-radius: 50%;
//   background: rgba(255,255,255,.15);
//   display: flex; align-items: center; justify-content: center;
//   font-size: 20px; flex-shrink: 0;
// }
// .appt-card-header-text { flex: 1; min-width: 0; }
// .appt-card-title { font-size: 16px; font-weight: 800; color: #fff; margin: 0; }
// .appt-card-sub   { font-size: 11px; color: rgba(255,255,255,.7); margin-top: 2px; }

// /* ── step sections ── */
// .appt-section { padding: 20px 24px 0; }
// .appt-section:last-child { padding-bottom: 24px; }
// .appt-section-label {
//   font-size: 11px; font-weight: 700; color: #64748b;
//   text-transform: uppercase; letter-spacing: .6px;
//   margin-bottom: 10px;
//   display: flex; align-items: center; gap: 6px;
// }
// .appt-section-label-dot {
//   width: 18px; height: 18px; border-radius: 50%;
//   background: linear-gradient(135deg,#0d7377,#14a0a5);
//   color: #fff; font-size: 9px; font-weight: 800;
//   display: flex; align-items: center; justify-content: center;
//   flex-shrink: 0;
// }
// .appt-divider { height: 1px; background: #f1f5f9; margin: 0 24px; }

// /* ── form inputs ── */
// .appt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
// .appt-inp-wrap  { display: flex; flex-direction: column; gap: 4px; }
// .appt-inp-wrap.full { grid-column: 1 / -1; }
// .appt-inp-label { font-size: 11px; font-weight: 600; color: #475569; }
// .appt-inp {
//   padding: 10px 12px; border-radius: 8px;
//   border: 1.5px solid #e2e8f0; font-size: 13px;
//   font-family: "DM Sans",sans-serif; outline: none;
//   transition: border-color .2s; background: #f8fafc;
//   width: 100%; box-sizing: border-box;
// }
// .appt-inp:focus { border-color: #0d7377; background: #fff; }
// .appt-textarea  { resize: vertical; min-height: 72px; }

// /* ── Practo date strip ── */
// .appt-date-strip {
//   display: flex;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none;
//   border: 1.5px solid #e2e8f0;
//   border-radius: 12px;
//   background: #f8fafc;
//   cursor: grab;
//   user-select: none;
// }
// .appt-date-strip.dragging { cursor: grabbing; }
// .appt-date-strip::-webkit-scrollbar { display: none; }
// .appt-date-pill {
//   flex-shrink: 0;
//   padding: 12px 16px; cursor: pointer;
//   text-align: center; min-width: 88px;
//   border-right: 1px solid #e2e8f0;
//   transition: background .15s;
//   font-family: "DM Sans",sans-serif;
//   -webkit-tap-highlight-color: transparent;
// }
// .appt-date-pill:last-child { border-right: none; }
// .appt-date-pill:hover  { background: rgba(13,115,119,.05); }
// .appt-date-pill.active { background: #0d7377; }
// .appt-date-day   { font-size: 13px; font-weight: 700; color: #1e293b; }
// .appt-date-avail { font-size: 10px; color: #16a34a; font-weight: 600; margin-top: 3px; }
// .appt-date-pill.active .appt-date-day   { color: #fff; }
// .appt-date-pill.active .appt-date-avail { color: rgba(255,255,255,.8); }
// .appt-date-scroll-hint {
//   font-size: 10px; color: #94a3b8;
//   margin-top: 5px; text-align: right;
// }

// /* ── date strip wrapper with arrows ── */
// .appt-date-wrapper {
//   position: relative;
//   display: flex;
//   align-items: center;
//   gap: 8px;
// }
// .appt-date-arrow {
//   flex-shrink: 0;
//   width: 34px; height: 34px;
//   border-radius: 50%;
//   border: 1.5px solid #e2e8f0;
//   background: #fff;
//   cursor: pointer;
//   display: flex; align-items: center; justify-content: center;
//   font-size: 16px; color: #0d7377; font-weight: 700;
//   transition: all .15s;
//   box-shadow: 0 1px 4px rgba(0,0,0,0.08);
//   user-select: none;
// }
// .appt-date-arrow:hover {
//   background: #0d7377; color: #fff; border-color: #0d7377;
// }
// .appt-date-arrow:active { transform: scale(0.93); }
// .appt-date-strip-wrap { flex: 1; min-width: 0; }
// /* hide arrows on mobile — touch scroll is enough */
// @media (max-width: 600px) {
//   .appt-date-arrow { display: none; }
// }

// /* ── selected date bar ── */
// .appt-date-bar {
//   background: #f8fafc; border: 1px solid #e2e8f0;
//   border-radius: 8px; padding: 9px 14px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
//   margin-bottom: 14px;
//   display: flex; align-items: center; justify-content: space-between;
// }
// .appt-date-bar-sub { color: #0d7377; font-size: 11px; font-weight: 600; }

// /* ── time period header ── */
// .appt-period-hdr {
//   display: flex; align-items: center; gap: 8px;
//   margin: 16px 0 10px;
//   font-size: 13px; font-weight: 700; color: #1e293b;
// }
// .appt-period-count {
//   background: #f1f5f9; border: 1px solid #e2e8f0;
//   border-radius: 20px; padding: 2px 10px;
//   font-size: 10px; color: #64748b; font-weight: 600;
// }

// /* ── slot grid — 4 columns ── */
// .appt-slots-grid {
//   display: grid;
//   grid-template-columns: repeat(4,1fr);
//   gap: 8px;
// }
// .appt-slot {
//   padding: 10px 6px; border-radius: 8px;
//   border: 1.5px solid #0d7377; background: #fff;
//   cursor: pointer; text-align: center;
//   transition: all .15s; font-family: "DM Sans",sans-serif;
// }
// .appt-slot:hover {
//   background: #0d7377;
// }
// .appt-slot:hover .appt-slot-time { color: #fff; }
// .appt-slot.selected { background: #0d7377; border-color: #0d7377; }
// .appt-slot.selected .appt-slot-time { color: #fff; }
// .appt-slot-time { font-size: 12px; font-weight: 700; color: #0d7377; }

// /* ── past/disabled slot ── */
// .appt-slot.past {
//   border-color: #e2e8f0; background: #f8fafc;
//   cursor: not-allowed; opacity: 0.45;
// }
// .appt-slot.past:hover { background: #f8fafc; }
// .appt-slot.past .appt-slot-time { color: #94a3b8; }
// .appt-slot.past:hover .appt-slot-time { color: #94a3b8; }

// /* ── submit button ── */
// .appt-submit {
//   width: 100%; padding: 14px;
//   background: linear-gradient(135deg,#25d366,#128c7e);
//   border: none; border-radius: 10px; cursor: pointer;
//   display: flex; align-items: center; justify-content: center; gap: 10px;
//   font-size: 15px; font-weight: 700; color: #fff;
//   font-family: "DM Sans",sans-serif;
//   transition: opacity .2s;
// }
// .appt-submit:hover     { opacity: .92; }
// .appt-submit:disabled  { opacity: .6; cursor: not-allowed; }

// /* ── doctor card ── */
// .appt-doc-card {
//   padding: 12px 14px; border-radius: 12px;
//   display: flex; align-items: center; gap: 12px;
//   border: 1px solid #e5e7eb; background: #f8fafc;
//   margin-bottom: 8px;
// }

// /* ── skeleton ── */
// @keyframes apptPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
// .appt-skel {
//   border-radius: 8px; background: #e2e8f0;
//   animation: apptPulse 1.5s ease-in-out infinite;
// }

// /* ══ RESPONSIVE ══════════════════════════════════════════════ */
// @media (max-width: 1024px) {
//   .appt-outer { gap: 48px; }
// }
// @media (max-width: 860px) {
//   .appt-outer {
//     grid-template-columns: 1fr !important;
//     gap: 28px !important;
//   }
//   .appt-card         { border-radius: 16px; }
//   .appt-card-header  { padding: 18px 20px 14px; }
//   .appt-section      { padding: 16px 18px 0; }
//   .appt-section:last-child { padding-bottom: 18px; }
//   .appt-divider      { margin: 0 18px; }
// }
// @media (max-width: 600px) {
//   .appt-card-header  { padding: 14px 16px 12px; }
//   .appt-card-title   { font-size: 14px; }
//   .appt-section      { padding: 14px 14px 0; }
//   .appt-section:last-child { padding-bottom: 16px; }
//   .appt-divider      { margin: 0 14px; }
//   .appt-form-grid    { grid-template-columns: 1fr !important; }
//   .appt-date-pill    { min-width: 72px; padding: 10px 10px; }
//   .appt-date-day     { font-size: 12px; }
//   .appt-slots-grid   { grid-template-columns: repeat(3,1fr) !important; gap: 6px; }
//   .appt-slot         { padding: 9px 4px; }
//   .appt-slot-time    { font-size: 11px; }
//   .appt-submit       { font-size: 14px; padding: 13px; }
// }
// @media (max-width: 380px) {
//   .appt-slots-grid        { grid-template-columns: repeat(2,1fr) !important; }
//   .appt-card-header-icon  { width: 34px; height: 34px; font-size: 16px; }
// }
// `;

// // ── Total slots for a date ────────────────────────────────────
// const TOTAL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots).length;

// export default function Appointment({ showToast }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     service: "",
//     date: localISO(new Date()),
//     time: "",
//     message: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [doctors, setDoctors] = useState([]);
//   const [doctorsLoaded, setDoctorsLoaded] = useState(false);
//   const [tick, setTick] = useState(0); // eslint-disable-line no-unused-vars

//   // Refs
//   const stripRef = useRef(null);
//   const mountedRef = useRef(false);

//   // ── Update current time every minute so past slots stay in sync ──
//   useEffect(() => {
//     // Tick every second — re-render so slots disable at exact time
//     const t = setInterval(() => setTick((n) => n + 1), 1000);
//     return () => clearInterval(t);
//   }, []);

//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   // ── Fetch doctors list ─────────────────────────────────────
//   useEffect(() => {
//     const base =
//       process.env.REACT_APP_API_URL ||
//       "https://pearlsmial.pearlsmilefresh.com/api";
//     let iv;
//     const go = () => {
//       fetch(base + "/auth/doctors")
//         .then((r) => (r.ok ? r.json() : null))
//         .then((data) => {
//           if (Array.isArray(data) && data.length > 0) {
//             setDoctors(data);
//             setDoctorsLoaded(true);
//           }
//         })
//         .catch(() => {});
//     };
//     go();
//     iv = setInterval(go, 10000);
//     return () => clearInterval(iv);
//   }, []);

//   // ── Date strip: drag-to-scroll (mouse + touch) ────────────
//   const isDragging = useRef(false);
//   const dragStartX = useRef(0);
//   const scrollStart = useRef(0);
//   const didDrag = useRef(false);

//   const onMouseDown = (e) => {
//     isDragging.current = true;
//     didDrag.current = false;
//     dragStartX.current = e.pageX;
//     scrollStart.current = stripRef.current.scrollLeft;
//     stripRef.current.classList.add("dragging");
//   };
//   const onMouseMove = (e) => {
//     if (!isDragging.current) return;
//     const dx = e.pageX - dragStartX.current;
//     if (Math.abs(dx) > 4) didDrag.current = true;
//     stripRef.current.scrollLeft = scrollStart.current - dx;
//   };
//   const onMouseUp = () => {
//     isDragging.current = false;
//     stripRef.current?.classList.remove("dragging");
//   };

//   // ── Scroll date strip on date change (after first user click) ──
//   useEffect(() => {
//     if (!mountedRef.current) {
//       mountedRef.current = true;
//       return;
//     }
//     if (!stripRef.current) return;
//     const idx = DAYS.findIndex((d) => d.iso === form.date);
//     if (idx < 0) return;
//     const pill = stripRef.current.children[idx];
//     if (pill) {
//       stripRef.current.scrollTo({
//         left:
//           pill.offsetLeft -
//           stripRef.current.offsetWidth / 2 +
//           pill.offsetWidth / 2,
//         behavior: "smooth",
//       });
//     }
//   }, [form.date]);

//   // ── Submit ─────────────────────────────────────────────────
//   const handleWhatsApp = async (e) => {
//     e.preventDefault();
//     if (
//       !form.name.trim() ||
//       !form.phone.trim() ||
//       !form.service ||
//       !form.date
//     ) {
//       alert("Please fill in Name, Phone, Service, and Date.");
//       return;
//     }
//     setSubmitting(true);
//     try {
//       await api.post("/appointments", form);
//       const msg = encodeURIComponent(
//         `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
//           `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}\n` +
//           `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
//           (form.message ? `*Message:* ${form.message}` : ""),
//       );
//       window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
//       showToast?.("✅ Appointment sent via WhatsApp!");
//       setForm({
//         name: "",
//         phone: "",
//         service: "",
//         date: localISO(new Date()),
//         time: "",
//         message: "",
//       });
//     } catch (err) {
//       showToast?.("❌ " + err.message);
//     }
//     setSubmitting(false);
//   };

//   const selectedDay = DAYS.find((d) => d.iso === form.date);
//   const selectedLabel = selectedDay?.full || form.date;

//   // Count available (non-past) slots for today on the date strip
//   const availableCount = (dateISO) => {
//     const todayISO = localISO(new Date());
//     if (dateISO !== todayISO) return TOTAL_SLOTS;
//     const n = new Date();
//     const nowMins = n.getHours() * 60 + n.getMinutes();
//     return TIME_GROUPS.flatMap((g) => g.slots).filter(
//       (s) => slotToMinutes(s) > nowMins,
//     ).length;
//   };

//   return (
//     <section className="appointment" id="appointment">
//       <style>{CSS}</style>

//       <div className="appointment-inner appt-outer">
//         {/* ── LEFT column ── */}
//         <div className="appt-left-info">
//           <div className="section-tag">Book Appointment</div>
//           <h2 className="section-title">
//             Let's Fix Your
//             <br />
//             <em>Smile Today</em>
//           </h2>
//           <p className="section-desc">
//             Pick a date and time that suits you. We'll confirm your appointment
//             via WhatsApp within 30 minutes.
//           </p>

//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div>
//                 <strong>{PHONE}</strong>
//                 <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">📍</div>
//               <div>
//                 <strong>12, Dental Plaza, MG Road</strong>
//                 <span>Pune, Maharashtra 411001</span>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div>
//                 <strong>care@pearlsmiledental.in</strong>
//                 <span>Response within 2 hours</span>
//               </div>
//             </div>
//           </div>

//           {/* Doctors */}
//           <div style={{ marginTop: 28 }}>
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 700,
//                 color: "#1e293b",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.5px",
//                 marginBottom: 12,
//               }}
//             >
//               🩺 Doctors Available Today
//             </div>

//             {!doctorsLoaded ? (
//               [1, 2, 3].map((i) => (
//                 <div key={i} className="appt-doc-card">
//                   <div
//                     className="appt-skel"
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       className="appt-skel"
//                       style={{ width: "60%", height: 13, marginBottom: 6 }}
//                     />
//                     <div
//                       className="appt-skel"
//                       style={{ width: "40%", height: 10 }}
//                     />
//                   </div>
//                   <div
//                     className="appt-skel"
//                     style={{ width: 80, height: 22, borderRadius: 12 }}
//                   />
//                 </div>
//               ))
//             ) : doctors.length === 0 ? (
//               <div
//                 style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
//               >
//                 Loading doctor info…
//               </div>
//             ) : (
//               doctors.map((doc) => (
//                 <div
//                   key={doc._id}
//                   className="appt-doc-card"
//                   style={{
//                     border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
//                     background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 38,
//                       height: 38,
//                       borderRadius: "50%",
//                       flexShrink: 0,
//                       background: `linear-gradient(135deg,${doc.isAvailable ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 17,
//                       color: "#fff",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {(doc.name || "D")
//                       .replace(/^Dr\.\s*/i, "")
//                       .charAt(0)
//                       .toUpperCase()}
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: doc.isAvailable ? "#166534" : "#991b1b",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       {doc.name}
//                     </div>
//                     <div
//                       style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
//                     >
//                       {doc.specialty || "General Dentist"}
//                     </div>
//                   </div>
//                   <span
//                     style={{
//                       padding: "3px 10px",
//                       borderRadius: 12,
//                       fontSize: 11,
//                       fontWeight: 700,
//                       flexShrink: 0,
//                       background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
//                       color: doc.isAvailable ? "#16a34a" : "#dc2626",
//                       border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
//                   </span>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* ── RIGHT column — booking card ── */}
//         <div style={{ minWidth: 0, width: "100%" }}>
//           <div className="appt-card">
//             {/* Header */}
//             <div className="appt-card-header">
//               <div className="appt-card-header-icon">🏥</div>
//               <div className="appt-card-header-text">
//                 <div className="appt-card-title">Clinic Visit Slots</div>
//                 <div className="appt-card-sub">
//                   PearlSmile Dental Hospital — Book online, confirm via WhatsApp
//                 </div>
//               </div>
//             </div>

//             {/* Step 1 — Details */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">1</span>
//                 Your Details
//               </div>
//               <div className="appt-form-grid">
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Full Name *</label>
//                   <input
//                     className="appt-inp"
//                     type="text"
//                     placeholder="e.g. Riya Sharma"
//                     value={form.name}
//                     onChange={(e) => set("name", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap">
//                   <label className="appt-inp-label">Phone Number *</label>
//                   <input
//                     className="appt-inp"
//                     type="tel"
//                     placeholder="+91 98765 43210"
//                     value={form.phone}
//                     onChange={(e) => set("phone", e.target.value)}
//                   />
//                 </div>
//                 <div className="appt-inp-wrap full">
//                   <label className="appt-inp-label">Service Required *</label>
//                   <select
//                     className="appt-inp"
//                     value={form.service}
//                     onChange={(e) => set("service", e.target.value)}
//                   >
//                     <option value="">— Select a service —</option>
//                     {SERVICES.map((s) => (
//                       <option key={s} value={s}>
//                         {s}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 2 — Date */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">2</span>
//                 Select Date
//               </div>
//               <div className="appt-date-wrapper">
//                 <button
//                   className="appt-date-arrow"
//                   onClick={() => {
//                     if (stripRef.current)
//                       stripRef.current.scrollBy({
//                         left: -180,
//                         behavior: "smooth",
//                       });
//                   }}
//                 >
//                   &#8249;
//                 </button>
//                 <div className="appt-date-strip-wrap">
//                   <div
//                     className="appt-date-strip"
//                     ref={stripRef}
//                     onMouseDown={onMouseDown}
//                     onMouseMove={onMouseMove}
//                     onMouseUp={onMouseUp}
//                     onMouseLeave={onMouseUp}
//                   >
//                     {DAYS.map((d) => {
//                       const avail = availableCount(d.iso);
//                       return (
//                         <div
//                           key={d.iso}
//                           className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
//                           onClick={() => {
//                             if (!didDrag.current) {
//                               set("date", d.iso);
//                               set("time", "");
//                             }
//                           }}
//                         >
//                           <div className="appt-date-day">{d.short}</div>
//                           <div className="appt-date-avail">{avail} slots</div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//                 <button
//                   className="appt-date-arrow"
//                   onClick={() => {
//                     if (stripRef.current)
//                       stripRef.current.scrollBy({
//                         left: 180,
//                         behavior: "smooth",
//                       });
//                   }}
//                 >
//                   &#8250;
//                 </button>
//               </div>
//               <div className="appt-date-scroll-hint">
//                 ← scroll for more dates →
//               </div>
//             </div>

//             <div className="appt-divider" />

//             {/* Step 3 — Time */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">3</span>
//                 Select Time Slot
//               </div>

//               <div className="appt-date-bar">
//                 <strong>{selectedLabel}</strong>
//                 <span className="appt-date-bar-sub">
//                   {availableCount(form.date)} slots available
//                 </span>
//               </div>

//               {TIME_GROUPS.map((group) => {
//                 const availSlots = group.slots.filter(
//                   (s) => !isSlotPast(s, form.date),
//                 );
//                 return (
//                   <div key={group.label}>
//                     <div className="appt-period-hdr">
//                       <span style={{ fontSize: 18 }}>{group.icon}</span>
//                       <span>{group.label}</span>
//                       <span className="appt-period-count">
//                         {availSlots.length} slots
//                       </span>
//                     </div>
//                     <div className="appt-slots-grid">
//                       {group.slots.map((t) => {
//                         const past = isSlotPast(t, form.date);
//                         return (
//                           <div
//                             key={t}
//                             className={`appt-slot${form.time === t ? " selected" : ""}${past ? " past" : ""}`}
//                             onClick={() => {
//                               if (!past) set("time", form.time === t ? "" : t);
//                             }}
//                             title={past ? "This slot has passed" : ""}
//                           >
//                             <div className="appt-slot-time">{t}</div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>

//             <div className="appt-divider" />

//             {/* Step 4 — Message + Submit */}
//             <div className="appt-section">
//               <div className="appt-section-label">
//                 <span className="appt-section-label-dot">4</span>
//                 Message (Optional)
//               </div>

//               <textarea
//                 className="appt-inp appt-textarea"
//                 placeholder="Describe your concern or any special instructions…"
//                 value={form.message}
//                 onChange={(e) => set("message", e.target.value)}
//               />

//               {form.time && (
//                 <div
//                   style={{
//                     marginTop: 12,
//                     padding: "10px 14px",
//                     borderRadius: 8,
//                     background: "rgba(13,115,119,.06)",
//                     border: "1px solid rgba(13,115,119,.2)",
//                     fontSize: 12,
//                     color: "#0d7377",
//                     fontWeight: 600,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 6,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   ✅ Selected:&nbsp;<strong>{selectedLabel}</strong>
//                   &nbsp;at&nbsp;<strong>{form.time}</strong>
//                 </div>
//               )}

//               <button
//                 className="appt-submit"
//                 onClick={handleWhatsApp}
//                 disabled={submitting}
//                 style={{ marginTop: 14 }}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                   <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
//                 </svg>
//                 {submitting ? "Sending…" : "Book via WhatsApp →"}
//               </button>

//               <div
//                 style={{
//                   textAlign: "center",
//                   marginTop: 10,
//                   fontSize: 11,
//                   color: "#94a3b8",
//                 }}
//               >
//                 You'll receive a confirmation call/WhatsApp within 30 minutes.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

/////////////////////////////// add doctor feild for patient///////////////////////
// ============================================================
// src/components/Appointment.js
// Practo-style booking interface — fully responsive
// NO auto-scroll on load, NO slot countdown
// Past time slots disabled for today
// ============================================================
import React, { useState, useEffect, useRef } from "react";
import api from "../utils/api";

const PHONE = "+91 87936 08083";
const WA_NUMBER = "918793608083";

// ── Local ISO date (no UTC shift) ────────────────────────────
function localISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// ── Next 14 days ─────────────────────────────────────────────
function getNext14Days() {
  const days = [];
  for (let i = 0; i < 14; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    const iso = localISO(d);
    const short = d.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
    const full = d.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
    days.push({
      iso,
      short: i === 0 ? "Today" : i === 1 ? "Tomorrow" : short,
      full: i === 0 ? "Today" : i === 1 ? "Tomorrow" : full,
    });
  }
  return days;
}
const DAYS = getNext14Days();

// ── Time slots ────────────────────────────────────────────────
const TIME_GROUPS = [
  {
    label: "Morning",
    icon: "🌅",
    slots: [
      "09:00 AM",
      "09:15 AM",
      "09:30 AM",
      "09:45 AM",
      "10:00 AM",
      "10:15 AM",
      "10:30 AM",
      "10:45 AM",
      "11:00 AM",
      "11:15 AM",
      "11:30 AM",
      "11:45 AM",
    ],
  },
  {
    label: "Afternoon",
    icon: "☀️",
    slots: [
      "12:00 PM",
      "12:15 PM",
      "12:30 PM",
      "12:45 PM",
      "01:00 PM",
      "01:15 PM",
      "01:30 PM",
      "01:45 PM",
      "02:00 PM",
      "02:15 PM",
      "02:30 PM",
      "02:45 PM",
      "03:00 PM",
      "03:15 PM",
      "03:30 PM",
      "03:45 PM",
    ],
  },
  {
    label: "Evening",
    icon: "🌆",
    slots: [
      "04:00 PM",
      "04:15 PM",
      "04:30 PM",
      "04:45 PM",
      "05:00 PM",
      "05:15 PM",
      "05:30 PM",
      "05:45 PM",
      "06:00 PM",
      "06:15 PM",
      "06:30 PM",
      "06:45 PM",
      "07:00 PM",
    ],
  },
];

const SERVICES = [
  "General Checkup & Cleaning",
  "Teeth Whitening",
  "Dental Implants",
  "Root Canal",
  "Orthodontics / Invisalign",
  "Cosmetic Dentistry",
  "Pediatric Dentistry",
  "Emergency Care",
  "Other",
];

// ── Convert "09:00 AM" → minutes since midnight ───────────────
function slotToMinutes(slot) {
  const [time, period] = slot.split(" ");
  let [h, m] = time.split(":").map(Number);
  if (period === "PM" && h !== 12) h += 12;
  if (period === "AM" && h === 12) h = 0;
  return h * 60 + m;
}

// ── Is this slot in the past for today? ───────────────────────
function isSlotPast(slot, selectedDate) {
  const todayISO = localISO(new Date());
  if (selectedDate !== todayISO) return false; // future dates — never disabled
  const now = new Date();
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  return slotToMinutes(slot) <= nowMinutes;
}

// ── CSS ───────────────────────────────────────────────────────
const CSS = `
/* ── outer layout ── */
.appt-outer {
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 72px;
  align-items: start;
}

/* ── left panel ── */
.appt-left-info { display: flex; flex-direction: column; }

/* ── booking card ── */
.appt-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 32px rgba(0,0,0,.08);
  overflow: hidden;
}
.appt-card-header {
  background: linear-gradient(135deg,#0a1628 0%,#0d7377 100%);
  padding: 22px 28px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.appt-card-header-icon {
  width: 42px; height: 42px; border-radius: 50%;
  background: rgba(255,255,255,.15);
  display: flex; align-items: center; justify-content: center;
  font-size: 20px; flex-shrink: 0;
}
.appt-card-header-text { flex: 1; min-width: 0; }
.appt-card-title { font-size: 16px; font-weight: 800; color: #fff; margin: 0; }
.appt-card-sub   { font-size: 11px; color: rgba(255,255,255,.7); margin-top: 2px; }

/* ── step sections ── */
.appt-section { padding: 20px 24px 0; }
.appt-section:last-child { padding-bottom: 24px; }
.appt-section-label {
  font-size: 11px; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: .6px;
  margin-bottom: 10px;
  display: flex; align-items: center; gap: 6px;
}
.appt-section-label-dot {
  width: 18px; height: 18px; border-radius: 50%;
  background: linear-gradient(135deg,#0d7377,#14a0a5);
  color: #fff; font-size: 9px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.appt-divider { height: 1px; background: #f1f5f9; margin: 0 24px; }

/* ── form inputs ── */
.appt-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.appt-inp-wrap  { display: flex; flex-direction: column; gap: 4px; }
.appt-inp-wrap.full { grid-column: 1 / -1; }
.appt-inp-label { font-size: 11px; font-weight: 600; color: #475569; }
.appt-inp {
  padding: 10px 12px; border-radius: 8px;
  border: 1.5px solid #e2e8f0; font-size: 13px;
  font-family: "DM Sans",sans-serif; outline: none;
  transition: border-color .2s; background: #f8fafc;
  width: 100%; box-sizing: border-box;
}
.appt-inp:focus { border-color: #0d7377; background: #fff; }
.appt-textarea  { resize: vertical; min-height: 72px; }

/* ── Practo date strip ── */
.appt-date-strip {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  cursor: grab;
  user-select: none;
}
.appt-date-strip.dragging { cursor: grabbing; }
.appt-date-strip::-webkit-scrollbar { display: none; }
.appt-date-pill {
  flex-shrink: 0;
  padding: 12px 16px; cursor: pointer;
  text-align: center; min-width: 88px;
  border-right: 1px solid #e2e8f0;
  transition: background .15s;
  font-family: "DM Sans",sans-serif;
  -webkit-tap-highlight-color: transparent;
}
.appt-date-pill:last-child { border-right: none; }
.appt-date-pill:hover  { background: rgba(13,115,119,.05); }
.appt-date-pill.active { background: #0d7377; }
.appt-date-day   { font-size: 13px; font-weight: 700; color: #1e293b; }
.appt-date-avail { font-size: 10px; color: #16a34a; font-weight: 600; margin-top: 3px; }
.appt-date-pill.active .appt-date-day   { color: #fff; }
.appt-date-pill.active .appt-date-avail { color: rgba(255,255,255,.8); }
.appt-date-scroll-hint {
  font-size: 10px; color: #94a3b8;
  margin-top: 5px; text-align: right;
}

/* ── date strip wrapper with arrows ── */
.appt-date-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}
.appt-date-arrow {
  flex-shrink: 0;
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; color: #0d7377; font-weight: 700;
  transition: all .15s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  user-select: none;
}
.appt-date-arrow:hover {
  background: #0d7377; color: #fff; border-color: #0d7377;
}
.appt-date-arrow:active { transform: scale(0.93); }
.appt-date-strip-wrap { flex: 1; min-width: 0; }
/* hide arrows on mobile — touch scroll is enough */
@media (max-width: 600px) {
  .appt-date-arrow { display: none; }
}

/* ── selected date bar ── */
.appt-date-bar {
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 8px; padding: 9px 14px;
  font-size: 13px; font-weight: 700; color: #1e293b;
  margin-bottom: 14px;
  display: flex; align-items: center; justify-content: space-between;
}
.appt-date-bar-sub { color: #0d7377; font-size: 11px; font-weight: 600; }

/* ── time period header ── */
.appt-period-hdr {
  display: flex; align-items: center; gap: 8px;
  margin: 16px 0 10px;
  font-size: 13px; font-weight: 700; color: #1e293b;
}
.appt-period-count {
  background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 20px; padding: 2px 10px;
  font-size: 10px; color: #64748b; font-weight: 600;
}

/* ── slot grid — 4 columns ── */
.appt-slots-grid {
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap: 8px;
}
.appt-slot {
  padding: 10px 6px; border-radius: 8px;
  border: 1.5px solid #0d7377; background: #fff;
  cursor: pointer; text-align: center;
  transition: all .15s; font-family: "DM Sans",sans-serif;
}
.appt-slot:hover {
  background: #0d7377;
}
.appt-slot:hover .appt-slot-time { color: #fff; }
.appt-slot.selected { background: #0d7377; border-color: #0d7377; }
.appt-slot.selected .appt-slot-time { color: #fff; }
.appt-slot-time { font-size: 12px; font-weight: 700; color: #0d7377; }

/* ── past/disabled slot ── */
.appt-slot.past {
  border-color: #e2e8f0; background: #f8fafc;
  cursor: not-allowed; opacity: 0.45;
}
.appt-slot.past:hover { background: #f8fafc; }
.appt-slot.past .appt-slot-time { color: #94a3b8; }
.appt-slot.past:hover .appt-slot-time { color: #94a3b8; }

/* ── submit button ── */
.appt-submit {
  width: 100%; padding: 14px;
  background: linear-gradient(135deg,#25d366,#128c7e);
  border: none; border-radius: 10px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  font-size: 15px; font-weight: 700; color: #fff;
  font-family: "DM Sans",sans-serif;
  transition: opacity .2s;
}
.appt-submit:hover     { opacity: .92; }
.appt-submit:disabled  { opacity: .6; cursor: not-allowed; }

/* ── doctor card ── */
.appt-doc-card {
  padding: 12px 14px; border-radius: 12px;
  display: flex; align-items: center; gap: 12px;
  border: 1px solid #e5e7eb; background: #f8fafc;
  margin-bottom: 8px;
}

/* ── skeleton ── */
@keyframes apptPulse { 0%,100%{opacity:1} 50%{opacity:.45} }
.appt-skel {
  border-radius: 8px; background: #e2e8f0;
  animation: apptPulse 1.5s ease-in-out infinite;
}

/* ══ RESPONSIVE ══════════════════════════════════════════════ */
@media (max-width: 1024px) {
  .appt-outer { gap: 48px; }
}
@media (max-width: 860px) {
  .appt-outer {
    grid-template-columns: 1fr !important;
    gap: 28px !important;
  }
  .appt-card         { border-radius: 16px; }
  .appt-card-header  { padding: 18px 20px 14px; }
  .appt-section      { padding: 16px 18px 0; }
  .appt-section:last-child { padding-bottom: 18px; }
  .appt-divider      { margin: 0 18px; }
}
@media (max-width: 600px) {
  .appt-card-header  { padding: 14px 16px 12px; }
  .appt-card-title   { font-size: 14px; }
  .appt-section      { padding: 14px 14px 0; }
  .appt-section:last-child { padding-bottom: 16px; }
  .appt-divider      { margin: 0 14px; }
  .appt-form-grid    { grid-template-columns: 1fr !important; }
  .appt-date-pill    { min-width: 72px; padding: 10px 10px; }
  .appt-date-day     { font-size: 12px; }
  .appt-slots-grid   { grid-template-columns: repeat(3,1fr) !important; gap: 6px; }
  .appt-slot         { padding: 9px 4px; }
  .appt-slot-time    { font-size: 11px; }
  .appt-submit       { font-size: 14px; padding: 13px; }
}
@media (max-width: 380px) {
  .appt-slots-grid        { grid-template-columns: repeat(2,1fr) !important; }
  .appt-card-header-icon  { width: 34px; height: 34px; font-size: 16px; }
}
`;

// ── Total slots for a date ────────────────────────────────────
const TOTAL_SLOTS = TIME_GROUPS.flatMap((g) => g.slots).length;

export default function Appointment({ showToast }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    service: "",
    doctor: "",
    date: localISO(new Date()),
    time: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [doctorsLoaded, setDoctorsLoaded] = useState(false);
  const [tick, setTick] = useState(0); // eslint-disable-line no-unused-vars

  // Refs
  const stripRef = useRef(null);
  const mountedRef = useRef(false);

  // ── Update current time every minute so past slots stay in sync ──
  useEffect(() => {
    // Tick every second — re-render so slots disable at exact time
    const t = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  // ── Fetch doctors list ─────────────────────────────────────
  useEffect(() => {
    const base =
      process.env.REACT_APP_API_URL ||
      "https://pearlsmial.pearlsmilefresh.com/api";
    let iv;
    const go = () => {
      fetch(base + "/auth/doctors")
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (Array.isArray(data) && data.length > 0) {
            setDoctors(data);
            setDoctorsLoaded(true);
          }
        })
        .catch(() => {});
    };
    go();
    iv = setInterval(go, 10000);
    return () => clearInterval(iv);
  }, []);

  // ── Date strip: drag-to-scroll (mouse + touch) ────────────
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const scrollStart = useRef(0);
  const didDrag = useRef(false);

  const onMouseDown = (e) => {
    isDragging.current = true;
    didDrag.current = false;
    dragStartX.current = e.pageX;
    scrollStart.current = stripRef.current.scrollLeft;
    stripRef.current.classList.add("dragging");
  };
  const onMouseMove = (e) => {
    if (!isDragging.current) return;
    const dx = e.pageX - dragStartX.current;
    if (Math.abs(dx) > 4) didDrag.current = true;
    stripRef.current.scrollLeft = scrollStart.current - dx;
  };
  const onMouseUp = () => {
    isDragging.current = false;
    stripRef.current?.classList.remove("dragging");
  };

  // ── Scroll date strip on date change (after first user click) ──
  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }
    if (!stripRef.current) return;
    const idx = DAYS.findIndex((d) => d.iso === form.date);
    if (idx < 0) return;
    const pill = stripRef.current.children[idx];
    if (pill) {
      stripRef.current.scrollTo({
        left:
          pill.offsetLeft -
          stripRef.current.offsetWidth / 2 +
          pill.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }, [form.date]);

  // ── Submit ─────────────────────────────────────────────────
  const handleWhatsApp = async (e) => {
    e.preventDefault();
    if (
      !form.name.trim() ||
      !form.phone.trim() ||
      !form.service ||
      !form.date
    ) {
      alert("Please fill in Name, Phone, Service, and Date.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/appointments", form);
      const msg = encodeURIComponent(
        `*PearlSmile Dental Hospital* — New Appointment Request\n\n` +
          `*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Service:* ${form.service}${form.doctor ? "\n*Preferred Doctor:* " + form.doctor : ""}\n` +
          `*Date:* ${form.date}${form.time ? "\n*Time:* " + form.time : ""}\n` +
          (form.message ? `*Message:* ${form.message}` : ""),
      );
      window.open(`https://wa.me/${WA_NUMBER}?text=${msg}`, "_blank");
      showToast?.("✅ Appointment sent via WhatsApp!");
      setForm({
        name: "",
        phone: "",
        service: "",
        doctor: "",
        date: localISO(new Date()),
        time: "",
        message: "",
      });
    } catch (err) {
      showToast?.("❌ " + err.message);
    }
    setSubmitting(false);
  };

  const selectedDay = DAYS.find((d) => d.iso === form.date);
  const selectedLabel = selectedDay?.full || form.date;

  // Count available (non-past) slots for today on the date strip
  const availableCount = (dateISO) => {
    const todayISO = localISO(new Date());
    if (dateISO !== todayISO) return TOTAL_SLOTS;
    const n = new Date();
    const nowMins = n.getHours() * 60 + n.getMinutes();
    return TIME_GROUPS.flatMap((g) => g.slots).filter(
      (s) => slotToMinutes(s) > nowMins,
    ).length;
  };

  return (
    <section className="appointment" id="appointment">
      <style>{CSS}</style>

      <div className="appointment-inner appt-outer">
        {/* ── LEFT column ── */}
        <div className="appt-left-info">
          <div className="section-tag">Book Appointment</div>
          <h2 className="section-title">
            Let's Fix Your
            <br />
            <em>Smile Today</em>
          </h2>
          <p className="section-desc">
            Pick a date and time that suits you. We'll confirm your appointment
            via WhatsApp within 30 minutes.
          </p>

          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <div>
                <strong>{PHONE}</strong>
                <span>Mon–Sat 8am–8pm, Sun 9am–5pm</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <div>
                <strong>12, Dental Plaza, MG Road</strong>
                <span>Pune, Maharashtra 411001</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div>
                <strong>care@pearlsmiledental.in</strong>
                <span>Response within 2 hours</span>
              </div>
            </div>
          </div>

          {/* Doctors */}
          <div style={{ marginTop: 28 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#1e293b",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: 12,
              }}
            >
              🩺 Doctors Available Today
            </div>

            {!doctorsLoaded ? (
              [1, 2, 3].map((i) => (
                <div key={i} className="appt-doc-card">
                  <div
                    className="appt-skel"
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      className="appt-skel"
                      style={{ width: "60%", height: 13, marginBottom: 6 }}
                    />
                    <div
                      className="appt-skel"
                      style={{ width: "40%", height: 10 }}
                    />
                  </div>
                  <div
                    className="appt-skel"
                    style={{ width: 80, height: 22, borderRadius: 12 }}
                  />
                </div>
              ))
            ) : doctors.length === 0 ? (
              <div
                style={{ fontSize: 13, color: "#94a3b8", padding: "12px 0" }}
              >
                Loading doctor info…
              </div>
            ) : (
              doctors.map((doc) => (
                <div
                  key={doc._id}
                  className="appt-doc-card"
                  style={{
                    border: `1px solid ${doc.isAvailable ? "#bbf7d0" : "#fecaca"}`,
                    background: doc.isAvailable ? "#f0fdf4" : "#fef2f2",
                  }}
                >
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      flexShrink: 0,
                      background: `linear-gradient(135deg,${doc.isAvailable ? "#0d7377,#14a0a5" : "#dc2626,#ef4444"})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 17,
                      color: "#fff",
                      fontWeight: 700,
                    }}
                  >
                    {(doc.name || "D")
                      .replace(/^Dr\.\s*/i, "")
                      .charAt(0)
                      .toUpperCase()}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: doc.isAvailable ? "#166534" : "#991b1b",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {doc.name}
                    </div>
                    <div
                      style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}
                    >
                      {doc.specialty || "General Dentist"}
                    </div>
                  </div>
                  <span
                    style={{
                      padding: "3px 10px",
                      borderRadius: 12,
                      fontSize: 11,
                      fontWeight: 700,
                      flexShrink: 0,
                      background: doc.isAvailable ? "#dcfce7" : "#fee2e2",
                      color: doc.isAvailable ? "#16a34a" : "#dc2626",
                      border: `1px solid ${doc.isAvailable ? "#16a34a" : "#dc2626"}`,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {doc.isAvailable ? "✅ Available" : "❌ Unavailable"}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* ── RIGHT column — booking card ── */}
        <div style={{ minWidth: 0, width: "100%" }}>
          <div className="appt-card">
            {/* Header */}
            <div className="appt-card-header">
              <div className="appt-card-header-icon">🏥</div>
              <div className="appt-card-header-text">
                <div className="appt-card-title">Clinic Visit Slots</div>
                <div className="appt-card-sub">
                  PearlSmile Dental Hospital — Book online, confirm via WhatsApp
                </div>
              </div>
            </div>

            {/* Step 1 — Details */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">1</span>
                Your Details
              </div>
              <div className="appt-form-grid">
                <div className="appt-inp-wrap">
                  <label className="appt-inp-label">Full Name *</label>
                  <input
                    className="appt-inp"
                    type="text"
                    placeholder="e.g. Riya Sharma"
                    value={form.name}
                    onChange={(e) => set("name", e.target.value)}
                  />
                </div>
                <div className="appt-inp-wrap">
                  <label className="appt-inp-label">Phone Number *</label>
                  <input
                    className="appt-inp"
                    type="tel"
                    placeholder="+91 98765 43210"
                    value={form.phone}
                    onChange={(e) => set("phone", e.target.value)}
                  />
                </div>
                <div className="appt-inp-wrap full">
                  <label className="appt-inp-label">Service Required *</label>
                  <select
                    className="appt-inp"
                    value={form.service}
                    onChange={(e) => set("service", e.target.value)}
                  >
                    <option value="">— Select a service —</option>
                    {SERVICES.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="appt-inp-wrap full">
                  <label className="appt-inp-label">
                    Preferred Doctor (Optional)
                  </label>
                  <select
                    className="appt-inp"
                    value={form.doctor}
                    onChange={(e) => set("doctor", e.target.value)}
                  >
                    <option value="">— No preference —</option>
                    {doctors.map((doc) => (
                      <option
                        key={doc._id}
                        value={doc.name}
                        disabled={!doc.isAvailable}
                      >
                        {doc.name}
                        {doc.specialty ? " — " + doc.specialty : ""}
                        {!doc.isAvailable ? " (Unavailable)" : ""}
                      </option>
                    ))}
                  </select>
                  {form.doctor && (
                    <div
                      style={{
                        marginTop: 6,
                        fontSize: 11,
                        color: "#0d7377",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      ✅ Preferred: <strong>{form.doctor}</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="appt-divider" />

            {/* Step 2 — Date */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">2</span>
                Select Date
              </div>
              <div className="appt-date-wrapper">
                <button
                  className="appt-date-arrow"
                  onClick={() => {
                    if (stripRef.current)
                      stripRef.current.scrollBy({
                        left: -180,
                        behavior: "smooth",
                      });
                  }}
                >
                  &#8249;
                </button>
                <div className="appt-date-strip-wrap">
                  <div
                    className="appt-date-strip"
                    ref={stripRef}
                    onMouseDown={onMouseDown}
                    onMouseMove={onMouseMove}
                    onMouseUp={onMouseUp}
                    onMouseLeave={onMouseUp}
                  >
                    {DAYS.map((d) => {
                      const avail = availableCount(d.iso);
                      return (
                        <div
                          key={d.iso}
                          className={`appt-date-pill${form.date === d.iso ? " active" : ""}`}
                          onClick={() => {
                            if (!didDrag.current) {
                              set("date", d.iso);
                              set("time", "");
                            }
                          }}
                        >
                          <div className="appt-date-day">{d.short}</div>
                          <div className="appt-date-avail">{avail} slots</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <button
                  className="appt-date-arrow"
                  onClick={() => {
                    if (stripRef.current)
                      stripRef.current.scrollBy({
                        left: 180,
                        behavior: "smooth",
                      });
                  }}
                >
                  &#8250;
                </button>
              </div>
              <div className="appt-date-scroll-hint">
                ← scroll for more dates →
              </div>
            </div>

            <div className="appt-divider" />

            {/* Step 3 — Time */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">3</span>
                Select Time Slot
              </div>

              <div className="appt-date-bar">
                <strong>{selectedLabel}</strong>
                <span className="appt-date-bar-sub">
                  {availableCount(form.date)} slots available
                </span>
              </div>

              {TIME_GROUPS.map((group) => {
                const availSlots = group.slots.filter(
                  (s) => !isSlotPast(s, form.date),
                );
                return (
                  <div key={group.label}>
                    <div className="appt-period-hdr">
                      <span style={{ fontSize: 18 }}>{group.icon}</span>
                      <span>{group.label}</span>
                      <span className="appt-period-count">
                        {availSlots.length} slots
                      </span>
                    </div>
                    <div className="appt-slots-grid">
                      {group.slots.map((t) => {
                        const past = isSlotPast(t, form.date);
                        return (
                          <div
                            key={t}
                            className={`appt-slot${form.time === t ? " selected" : ""}${past ? " past" : ""}`}
                            onClick={() => {
                              if (!past) set("time", form.time === t ? "" : t);
                            }}
                            title={past ? "This slot has passed" : ""}
                          >
                            <div className="appt-slot-time">{t}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="appt-divider" />

            {/* Step 4 — Message + Submit */}
            <div className="appt-section">
              <div className="appt-section-label">
                <span className="appt-section-label-dot">4</span>
                Message (Optional)
              </div>

              <textarea
                className="appt-inp appt-textarea"
                placeholder="Describe your concern or any special instructions…"
                value={form.message}
                onChange={(e) => set("message", e.target.value)}
              />

              {form.time && (
                <div
                  style={{
                    marginTop: 12,
                    padding: "10px 14px",
                    borderRadius: 8,
                    background: "rgba(13,115,119,.06)",
                    border: "1px solid rgba(13,115,119,.2)",
                    fontSize: 12,
                    color: "#0d7377",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    flexWrap: "wrap",
                  }}
                >
                  ✅ Selected:&nbsp;<strong>{selectedLabel}</strong>
                  &nbsp;at&nbsp;<strong>{form.time}</strong>
                </div>
              )}

              <button
                className="appt-submit"
                onClick={handleWhatsApp}
                disabled={submitting}
                style={{ marginTop: 14 }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                  <path d="M11.982 0C5.364 0 0 5.373 0 11.999c0 2.119.554 4.11 1.523 5.838L0 24l6.335-1.617A11.939 11.939 0 0011.982 24C18.6 24 24 18.627 24 12c0-6.627-5.4-12-12.018-12zm0 21.818a9.818 9.818 0 01-4.978-1.354l-.357-.213-3.705.948.983-3.596-.235-.37A9.791 9.791 0 012.182 12C2.182 6.582 6.573 2.182 11.982 2.182 17.4 2.182 21.818 6.582 21.818 12c0 5.418-4.418 9.818-9.836 9.818z" />
                </svg>
                {submitting ? "Sending…" : "Book via WhatsApp →"}
              </button>

              <div
                style={{
                  textAlign: "center",
                  marginTop: 10,
                  fontSize: 11,
                  color: "#94a3b8",
                }}
              >
                You'll receive a confirmation call/WhatsApp within 30 minutes.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
